import { numLabel, floatNum } from './core/num-label.js';
import {escapeEntryAck,hellFieldAck} from './ui/escape-field.js';
import { lifeStoneUseAck, recoverLifeStoneUse } from './ui/lifestone-use.js';
import { configureInstallOffer } from './ui/install-offer.js';
import {receive as receiveTower, recoverTowerWrite} from './ui/panels/tower.js';
import { resolvePendingWrite } from './core/pending-write.js';
import { showReturnOptions, hideReturnOptions } from './ui/return-pick.js';
/** 진입점 — 모듈을 붙이고 루프를 돈다. */
import { S, $, esc, DEATH_DROP_TTL } from './core/state.js';
import { worldChanged } from './ui/notify.js';
import { initWorldNotify, refreshWorldNotify } from './ui/world-notify.js';
import { connect, disconnect, send, start, cancelStart, on, takeRejoin, nativeActionAllowed, forgetResume, retryNow, originalFieldAt,
  fieldDisplayName, requestFirstBossStart } from './core/net.js';
import { cueMoving, cueDone, cueEnded, cueWait, cueLog, cueTravelAck, cueWaiting, cueState, cuePhase, cueLinkUp, cueLinkWait, crossingTick, setSourceProbe, setCueRetry, fieldName } from './ui/crossing-cue.js';
import { travelOnState, travelOnFieldReturn, setTravelBusy } from './render/teleport-fx.js'; // F28 — 귀환·순간이동 떠남 → 이동 중 → 도착
import { initInput, setForce } from './core/input.js';
import { applyKeyHints } from './core/keymap.js';
import { applyFxPref } from './core/fx-pref.js';
import { initScene, initGpuScene, draw, float, setDrawHold } from './render/scene.js';
import { prefetchIsoArt, setIsoCover, isoSceneReady, isoArtState, isoView, ISO_COVER_MAX_MS } from './render/iso-scene.js';
import { hitFeel } from './render/hit-feel.js';
import { initQuality, shouldInitGpuLayers } from './render/quality.js';
import { initMini } from './render/minimap.js';
import { initFeed, syncHud, log, pushAnn } from './ui/hud.js';
import { goalKeyOf, goalGuideMode, goalAimRaw, clearGoalAim, followSuggestedGoal } from './ui/goal-aim.js'; // 목표 길잡이와 플레이어가 고른 원정
import { PK_WARN, PK_GLOSS } from './world/pk.js';
import { adsStatus, showRewarded } from './ui/ads.js';
import { floorAt, floorOf, settlementAt, zoneAt, NPCS, FLOORS } from './world/map.js';
import { where, canAct } from './world/places.js';
import { nativeFieldGeometry, nativeFieldFloor, nativeRegionId, nativeTownRegion } from './world/native-field.js';
import { siegeArenaAt } from './world/siege-map.js';
import { toast, flash } from './ui/toast.js';
import { onExchange, recoverExchangeWrite } from './ui/panels/exchange.js';
import { alchemyActionAck, bountyPostAck, contributionRanksAck, exchangeAck, goblinBuyAck, lotteryBuyAck, renameAck, recoverBoardWrites, recoverBountyPost, recoverLotteryPurchase, recoverTownWrites, togglePanel, closePanel, render as renderPanel, syncNewsBadge, openEvents, syncMenuDot } from './ui/panels/index.js';
import { gambleHubOpen } from './ui/panels/shop.js';
import { resetAdminForIdentitySwitch, wireAdmin } from './ui/admin-door.js'; // R209 — 콘솔 모듈은 콘솔을 열 때 처음 받는다
import { initGoogleAds, showInterstitial } from './ui/ads.js';
import { SFX, envAt, setMusicScene, setMusicDepth, setMusicConfig, soundOn, unlock, resumeSoundAfterInterruption, audioLeadMs } from './core/sound.js';
import { toggleWorldMap, openWorldMapAt } from './ui/world-map.js';   // Q276 — 늘 보이는 [지도] 칸·M 키
import { onImpact, setAudioLead } from './render/impact-bus.js';
import { syncSkills, castSkill } from './ui/skillbar.js';
import { initChat, toggleChat, chatOpen, onChat } from './ui/chat.js';
import { initSelect, backToSelect, refreshSelect, createStartOptions, enterCharacter } from './ui/select.js';
import { captureWorldRecap, showWorldRecap, worldRecapRules } from './ui/world-recap.js'; // 묶음 Y(14.429, G5)
import { askConfirm, cancelDialogs } from './ui/dialog.js';
import { initGoogleAuth, initNaverAuth, finishNaverAuth, finishGoogleRelay } from './ui/auth.js';
import { initInstall } from './ui/install.js';
import { initDomainRollout } from './ui/domain-rollout.js';
import { initActionDock } from './ui/mobile.js';
import { initTopLane } from './ui/top-lane.js';
import { prebakeIsoSpawn } from './render/scene.js'; // UI2a — 부트 즉시 첫마을 스폰 둘레 땅 굽기
import { setSourceSurroundingsEnabled, setSourceNativeFields, prefetchSourceSurroundings } from './render/source-surroundings.js';
import { bindIsoZoomWheel, isoZoomStep, announceStep } from './render/iso-zoom.js';
import { initAttackButton } from './ui/attack-button.js'; // Z1 — 손가락용 공격 버튼(자동 표적)
import { initScrollCue } from './ui/scrollcue.js';
import { initSupport } from './ui/support.js';
import { showBlackjackFanfare, showLotteryFanfare } from './ui/lottery-fanfare.js';
import { handleMockSiegeRecruit } from './ui/mock-siege-popup.js';
import { showSiegeRecall, clearSiegeRecall } from './ui/siege-recall.js';
import { deathLostLabels } from './ui/panels/common.js';
import { placeInfo } from './world/place-info.js';
import { onSlotAck, recoverSlotSpin } from './ui/panels/slot.js';
import { guildMoneyAck, restoreGuildMoney } from './ui/guild-money.js';
import { guildShopAck, restoreGuildShop } from './ui/guild-shop.js';
import { applyGuildBuildings } from './ui/guild-buildings.js';
import { initReadability } from './ui/readability.js';
import { createStoryIntro } from './ui/story.js';
import { arrivalLines, arrivalOffering } from './ui/arrival-lines.js'; // R228 — 막바지 도착 카드 문장
import { createHallCard } from './ui/hall-card.js';
import { beginQuietStart, endQuietStart, quietStart } from './ui/quiet-start.js';
import { landscapeHintShown } from './ui/landscape-hint.js';
import { loadGameFonts } from './core/game-fonts.js'; // 묶음 CL1 — 첫 화면은 글자 부분집합, 게임 안 원본 글꼴은 입장할 때

/**
 * SEAMLESS-R1(DESIGN 14.x) — 지상 경계(마을↔사냥터·사냥터↔사냥터)를 건널 때는
 * 전면 덮개를 쓰지 않는다. 마지막에 서 있던 화면을 그대로 둔다(입력·렌더는 안 막는다).
 * C9(DESIGN 14.476) — 작은 표시는 닿는 순간 뜨고(전에는 2초 뒤), 오래 걸려도 창을 띄우지 않는다
 * (전에는 20초 뒤 「사냥터 연결이 지연되고 있다」 전면 안내 — 관문 3). `ui/crossing-cue.js`.
 */
/**
 * R182(DESIGN 14.394) — 끊긴 몸은 서버 콘솔 「끊긴 몸 유지 시간」 동안 그 자리에 남는다(전투 중이면 최소 20초).
 * 그동안 몬스터에게 노출된다는 것까지 말한다 — 사용자 결정(노출돼도 괜찮다)을 화면이 숨기지 않는다.
 */
function linkHoldNote() {
  const secs = Number.isFinite(S.linkHoldSecs) ? S.linkHoldSecs : 60;
  return secs > 0
    ? `몸은 그 자리에 ${secs}초 남는다 — 그동안 몬스터에게 공격받을 수 있다. 다시 이어지면 그대로 이어 한다.`
    : '전투 중이었다면 몸은 그 자리에 최소 20초 남는다.';
}
/**
 * Q241 — 원천에 몸이 아예 없다(사냥터로 넘기는 도중 원천 서버가 다시 시작됐거나 끊긴 몸 유지 시간이 지나 저장·퇴장했다 — 넘김 준비가
 * `bodyLost` 로 알린다, net.js `enterNative`). 그때 「몸은 그 자리에 N초 남는다 — 공격받을 수 있다」는 사실이 아니다: 몸은 게임 안에 없고,
 * 다시 이어지면 마지막으로 저장된 자리에서 깨어난다.
 */
const LINK_BODY_LOST_NOTE = '캐릭터는 지금 게임 안에 없어 공격받지 않는다. 다시 이어지면 마지막으로 저장된 자리에서 이어 한다.';
/**
 * R198(DESIGN 14.404) — 끊김 덮개의 버튼 셋. [여기서 다시 시작] 은 세션을 새로 받는다(밀려났거나 이어 갈 수 없을 때),
 * [지금 다시 시도] 는 다음 재시도를 기다리지 않는다, [처음 화면으로] 는 캐릭터 선택으로 나간다 — 덮개가 하단 「나가기」 독을
 * 덮고 있어서, 이 버튼이 없으면 오래 끊겼을 때 새로고침 말고 나갈 길이 없었다.
 */
function linkButtons({ go = false, retry = false, home = false } = {}) {
  for (const [id, on] of [['#linkgo', go], ['#linkretry', retry], ['#linkhome', home]]) {
    const b = $(id); if (b) b.style.display = on ? '' : 'none';
  }
}
/**
 * R202(DESIGN 14.404) — 이어 갈 수 없는 끊김은 **사유대로** 말한다. 전에는 사냥터 확인 실패만 따로 말하고 나머지(운영자 정리·
 * 사냥터 바뀜·계정 확인)는 전부 「다른 곳에서 접속했다」라 해서, 한 탭만 쓰는 사람이 해킹을 의심했다. 모르는 사유는 일반 문장이다.
 * `go:false` 는 새 세션으로 이어 할 수 없는 사유 — [처음 화면으로] 만 준다.
 */
const LINK_DEAD = {
  'field unavailable': { head: '사냥터 연결을 확인하지 못했다', msg: '지금 이 사냥터에 들어갈 수 없다.',
    note: '잠시 뒤 다시 시작해 달라. 캐릭터 기록은 그대로다.', log: '사냥터 연결을 확인하지 못했다. 캐릭터 기록은 그대로다.' },
  // 묶음 T(DESIGN 14.420) — 사냥터가 이 캐릭터의 저장을 거듭 거절했다. 다시 붙어도 같은 몸이라 되풀이되므로 [처음 화면으로]만 준다
  'field save refused': { head: '이 캐릭터의 사냥터 상태를 저장하지 못했다', msg: '사냥터가 이 캐릭터의 저장을 거듭 거절해 다시 잇기를 멈췄다.', go: false,
    note: '처음 화면으로 돌아가 마을에서 다시 시작해 달라. 계속되면 운영자에게 알려 달라.', log: '사냥터가 이 캐릭터의 저장을 거듭 거절해 다시 잇기를 멈췄다.' },
  'taken over': { head: '다른 탭에서 접속했다', msg: '이 창의 연결은 멈췄다.',
    note: '같은 캐릭터를 다른 탭이나 창에서 열어 그쪽이 이어받았다. 여기서 이어 하려면 아래를 누른다 — 그러면 그쪽이 멈춘다.',
    log: '같은 캐릭터를 다른 탭에서 열어 이 창의 연결이 멈췄다. [여기서 다시 시작] 을 누르면 여기서 이어 한다.' },
  'session superseded': { head: '다른 곳에서 접속했다', msg: '이 창의 연결은 더 이상 쓸 수 없다.',
    note: '다른 탭이나 기기에서 같은 캐릭터로 들어갔다. 여기서 이어 하려면 아래를 누른다.',
    log: '다른 곳에서 접속해 이 창의 연결이 끊겼다. [여기서 다시 시작] 을 누르면 이어 할 수 있다.' },
  'session changed': { head: '접속 정보가 바뀌었다', msg: '이 창의 연결은 더 이상 쓸 수 없다.',
    note: '다른 탭·기기에서 다시 들어갔거나 로그인이 바뀌었다. 여기서 이어 하려면 아래를 누른다.',
    log: '접속 정보가 바뀌어 이 창의 연결이 끊겼다. [여기서 다시 시작] 을 누르면 이어 할 수 있다.' },
  'deleted by admin': { head: '캐릭터를 불러올 수 없다', msg: '운영자가 이 캐릭터를 정리했다.', go: false,
    note: '처음 화면에서 캐릭터 목록을 확인해 달라.', log: '운영자가 이 캐릭터를 정리해 연결이 끊겼다.' },
  'field identity changed': { head: '사냥터 정보가 바뀌었다', msg: '이 연결로는 이어 갈 수 없다.',
    note: '아래를 눌러 다시 접속하면 지금 사냥터로 들어간다. 캐릭터 기록은 그대로다.', log: '사냥터 정보가 바뀌어 연결이 끊겼다. 다시 접속해 달라.' },
  default: { head: '연결을 이어 갈 수 없다', msg: '이 창의 연결은 더 이상 쓸 수 없다.',
    note: '아래를 눌러 다시 접속해 달라. 캐릭터 기록은 그대로다.', log: '연결을 이어 갈 수 없어 멈췄다. [여기서 다시 시작] 을 누르면 이어 할 수 있다.' },
};
/**
 * C9(DESIGN 14.476) — 넘기기 표시는 `ui/crossing-cue.js` 가 맡는다: 닿는 순간 「이동 중 — 목적지」(2초를 기다리지 않는다), 오래 걸리면
 * 「연결 확인 중 — 잠시만」·「눌러서 다시 잇기」. 전에는 20초가 지나면 「사냥터 연결이 지연되고 있다」 창이 화면을 막았다(관문 3) — 이제 창은 없다.
 */
function showFieldShift(text = null, dest = null, kind = 'field') { cueMoving({ dest, text, kind }); }
/** R194 — 넘기는 동안 누른 입력은 보내지 못한다. 그 순간 표시를 곧바로 켠다 */
function showFieldShiftNow() { cueMoving({}); }
function hideFieldShift() { cueDone(); }
setSourceProbe((p) => originalFieldAt(p));
setCueRetry(() => { if (!S.connected) retryNow(); else connect(); });

let goalClaimUnlockTimer = 0;
function holdGoalClaim(native) {
  S.goalClaimBusy = true;
  clearTimeout(goalClaimUnlockTimer);
  goalClaimUnlockTimer = setTimeout(() => {
    S.goalClaimBusy = false;
    if (native && nativeFieldGeometry()) send({ t: 'fieldGoalsGet' });
  }, native ? 15000 : 1500);
}
function releaseGoalClaim() {
  clearTimeout(goalClaimUnlockTimer);
  goalClaimUnlockTimer = 0;
  S.goalClaimBusy = false;
}
/**
 * 묶음 Y(DESIGN 14.429, G9) — 사냥터에서 전투 중이라 거절된 목표 보상은 **싸움이 끝나는 대로 저절로 다시 받는다.**
 * 서버의 거절(goal_claim.rs `combat_lock` — 보상 수령이 몸을 얼리는 동안 맞지 않게 하는 저장 경계)은 그대로 두고,
 * 다시 보내는 쪽만 화면이 맡는다. 묶음 SM — 전투 중 거절은 **기계용 코드** `code:'in_combat'`(goal_claim.rs
 * `combat_refusal_frame`)로 알아본다. 전에는 거절 문장 첫머리를 봐서 러스트 문장이 바뀌면 조용히 옛 동작(한 번 거절)으로
 * 돌아갔다. 문장은 사람용으로만 남는다. `code` 가 아예 없는 옛 사냥터 서버에만 문장 첫머리를 본다(배포 순서 이행용).
 * 끄기: 콘솔 `growthFlowConfig.claimAfterCombat`(you.growthFlow.claimAfterCombat).
 */
const COMBAT_REFUSAL_LEGACY = /^(전투 중|몬스터가 쫓아오고|누군가 나를 노리고|장판 위|종말 드래곤의 브레스)/;
/** @param {{code?: string, message?: string}} m */
function isCombatRefusal(m) {
  if (m.code !== undefined) return m.code === 'in_combat';
  return COMBAT_REFUSAL_LEGACY.test(String(m.message || ''));
}
const CLAIM_RETRY_MS = 2000, CLAIM_PENDING_MAX_MS = 10 * 60 * 1000;
let lastGoalClaim = null;
function sendGoalClaim(msg) {
  lastGoalClaim = msg;
  holdGoalClaim(!!nativeFieldGeometry());
  send(msg);
}
function retryPendingGoalClaim() {
  const p = S.goalClaimPending;
  if (!p || S.goalClaimBusy || !S.connected || S.ws?.readyState !== 1 || !nativeFieldGeometry()) return;
  const now = Date.now();
  const still = p.msg.t === 'firstStepClaim' ? (S.you?.firstStep?.id === p.msg.id && S.you.firstStep.done)
    : !!S.you?.daily?.claim;
  if (!still || now - p.since > CLAIM_PENDING_MAX_MS) { S.goalClaimPending = null; return; }
  if (now - p.at < CLAIM_RETRY_MS) return;
  p.at = now; p.auto = true;
  sendGoalClaim(p.msg);
}

/**
 * R187(DESIGN 14.396) — 입장 진행 표시. 「입장」을 누른 **그 순간**부터 첫 화면(첫 상태 패킷)까지 가운데 판이 단계를 말한다.
 * 전에는 캐릭터 목록의 「입장」을 눌러도 문구가 숨은 새 캐릭터 버튼(#go)에서만 바뀌어 **아무 반응이 없어 보였고**(사용자 실보고),
 * 첫 입장이 지상 사냥터면 「끊김 없는 지상 이동」으로 취급돼 전면 판 없이 2초 뒤 작은 표시만 떴다 — 그사이 「연결이 끊겼다」 덮개가
 * 뜰 수도 있었다. 응답이 늦으면 늦다고 말하고(8초), 막히면 나갈 길을 준다(25초).
 * R195(DESIGN 14.404) — 첫 판 해제(`revealPage`)보다 **먼저** 선언한다. 해제는 모듈을 읽는 순간 걸리므로(글꼴 준비·0.3초) 이 값을
 * 읽을 수 있어야 한다.
 */
const entry = { on: false, slow: 0, stuck: 0, resumed: false, charId: null, settle: 0, settleTimer: 0, settleRun: null, at: 0 };

// ── 시작 화면 배경 ───────────────────────────────────────────────
/**
 * 첫 화면을 빈 검은 화면으로 두지 않고, critical DOM·스타일·타이틀 배경이
 * 한 번 그려진 뒤 열어 준다. 폰트 CDN이 느리거나 막혀도 2.5초 안에는 열리며,
 * 서비스워커가 보관한 타이틀 배경은 다음 방문부터 네트워크 왕복을 건너뛴다.
 *
 * R195(DESIGN 14.404) — 입장 판(`entry.on`)이 떠 있으면 건드리지 않는다. 같은 판(`#page-loading`)을 입장 진행도 쓰는데, 새로고침·배포
 * 자동 재입장은 모듈을 읽자마자 입장을 시작해서 먼저 걸어 둔 이 해제가 2프레임 뒤 입장 판을 꺼 버렸다 — 몸이 들어올 때까지 문구 없는
 * 검은 화면만 몇 초 보였고, 25초 「처음 화면으로」도 꺼진 판 위에 달려 안 보였다.
 */
function revealPage() {
  const el = $('#page-loading');
  // 묶음 AA(DESIGN 14.431) — 모듈보다 먼저 누른 [게임 시작]·재입장(`__unigeHold`, index.html 부트 스크립트)이 판을 켰으면 입장이 이어받는다
  if (!el || el.classList.contains('ready') || el.nativeTransitionActive || entry.on || window.__unigeHold) return;
  requestAnimationFrame(() => requestAnimationFrame(() => {
    if (!el.nativeTransitionActive && !entry.on && !window.__unigeHold) el.classList.add('ready');
  }));
}
/** 묶음 AA — 부트 전 누름·재입장 대기를 푼다. 입장이 이어받지 않았으면 판을 걷는다 */
function releaseHold() {
  if (!window.__unigeHold) return;
  window.__unigeHold = '';
  revealPage();
}
/** 묶음 AA — 입장 진행 막대(index.html `__unigeProgress`). 부트(받은 파일)가 0~0.35, 입장 단계가 그 뒤를 채운다 */
function entryProgress(p) { try { window.__unigeProgress?.(p); } catch { /* 옛 index.html — 막대는 흐름만 돈다 */ } }
if (document.fonts?.ready) {
  void document.fonts.ready.then(revealPage, revealPage);
} else {
  revealPage();
}
/**
 * R71(DESIGN 14.346) — 이 줄이 도는 시점엔 로컬 CSS·DOM·시작 버튼이 이미 준비돼 있다(모듈은
 * DOMContentLoaded 뒤에 돈다). 전에는 `load`(오디오·이미지 전부)나 2.5초를 기다려 덮개가
 * 시작 버튼을 가렸다 — 로컬 실측 2.6초가 첫 클릭 전에 그냥 흘렀다. 픽셀 폰트는 짧게만 기다리고,
 * 늦으면 대체 글꼴로 먼저 연다(폰트 CSS 도 더는 렌더를 막지 않는다 — index.html).
 */
setTimeout(revealPage, 300);

initReadability();
// R148 — 탭·PC 도구열·하단 독의 키 글자를 실제 키 표(core/keymap.js)에서 채운다. 캐릭터 선택 화면에서도 탭이 보인다.
applyKeyHints();
void initWorldNotify({ token: () => S.token, changed: () => { if (S.panel === 'help' || S.panel === 'settings') renderPanel(true); } });
// 홈 화면 설치 기회는 **첫 화면보다 먼저** 잡아둬야 한다 — 1회성 이벤트다
initInstall();
// 후원 링크는 플레이 상태와 무관한 안내 UI다. 한 번만 배선하고 게임이 보일 때 함께 보인다.
initSupport();
// 게시자 설정이 없거나 광고 차단기가 막아도 게임 시작과 분리된 열린 실패다.
void initGoogleAds();
addEventListener('unige:ads-status', () => {
  if (S.panel === 'sell') renderPanel(true);
});

(function stars() {
  const c = $('#stars'); if (!c) return;
  const g = c.getContext('2d');
  let dots = [];
  const reset = () => {
    c.width = innerWidth; c.height = innerHeight;
    dots = Array.from({ length: Math.min(150, Math.floor(innerWidth / 9)) }, () => ({
      x: Math.random() * innerWidth, y: Math.random() * innerHeight,
      s: Math.random() < 0.82 ? 1 : 2, v: 0.05 + Math.random() * 0.28,
      a: 0.12 + Math.random() * 0.5,
    }));
  };
  reset(); addEventListener('resize', reset);
  (function tick() {
    if ($('#start').style.display === 'none') return;
    requestAnimationFrame(tick);
    g.clearRect(0, 0, c.width, c.height);
    for (const d of dots) {
      d.y -= d.v; if (d.y < -2) { d.y = c.height + 2; d.x = Math.random() * c.width; }
      g.fillStyle = `rgba(212,168,60,${d.a})`;
      g.fillRect(d.x | 0, d.y | 0, d.s, d.s);
    }
  })();
})();

// ── 시작 화면 ────────────────────────────────────────────────────
let klass = 'melee';
document.querySelectorAll('.klass button').forEach((b) => {
  b.onclick = () => {
    document.querySelectorAll('.klass button').forEach((o) => {
      o.classList.remove('on'); o.setAttribute('aria-pressed', 'false');
    });
    b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); klass = b.dataset.k;
    prefetchIsoArt(klass, null, { starter: true });   // UI2a(14.441) — 고른 직업의 몸 새 도트를 누르기 전에 받아 둔다
  };
});
prefetchIsoArt(document.querySelector('.klass button.on')?.dataset.k || klass, null, { starter: true });   // UI2a — 기본 직업 몸·첫 걸음 몬스터도 부트 즉시
prefetchSourceSurroundings();   // MAP0 R4 — 마을에서 본 바깥(섬 마을 둘레 들판 정적 보기)을 부트 즉시 받는다 — 1.0 고리가 한 프레임도 안 보이게
prebakeIsoSpawn();   // UI2a — 새 몸이 설 첫마을 동문 밖 땅을 시작 화면의 쉬는 틈·판이 덮는 동안(연결 대기)에 굽는다
$('#nm').addEventListener('keydown', (e) => { if (e.key === 'Enter') $('#go').click(); });

/**
 * R187 — 사냥터로 넘어가는 중(`nativeTransition` 켜짐)인가. 넘어가는 동안은 새 소켓이 첫 상태를 받기 전까지 `S.connected` 가
 * 잠깐 거짓이다 — 그건 끊김이 아니다. 전에는 마을→사냥터를 걸어 넘을 때마다 「연결이 끊겼다」 전면 덮개가 번쩍였다.
 * 실제 재시도(`nativeRetry` — 넘기기를 끄고 재시도 횟수를 싣는다)는 그대로 덮개가 말한다.
 */
let fieldHandoff = false;
/** R194 — 지금 넘기기가 무엇인가(보내지 못한 입력을 말할 때 쓴다) */
let handoffDoing = '사냥터를 잇는 중이라';
/**
 * 묶음 X2(DESIGN 14.443) — 첫 입장 판이 덮는 동안, 갈 사냥터의 지형을 받기 전(원천 첫 상태만 온 때)은 그리지 않는다. 그 사이 원천 쪽
 * 청크를 굽느라 프레임이 길어져 사냥터 입장이 밀렸다. 지형을 받으면(소켓을 여는 동안) 곧바로 그 사냥터를 굽기 시작하고,
 * 첫 상태가 오면(`entryReady`) 예전처럼 판 뒤에서 다 굽고 판을 걷는다. 원천이 목적지면 첫 상태에서 곧장 `entryReady` 다.
 */
setDrawHold(() => entry.on && !entry.settle && fieldHandoff && !nativeFieldGeometry());
// F28 — 사냥터로 넘기는 중(원천이 몸을 사냥터 착지에 세운 뒤 새 사냥터 첫 상태까지)·입장 판이면 이동 연출이 「도착」으로 보지 않는다
setTravelBusy(() => fieldHandoff || entry.on);
function entryParts() {
  const el = $('#page-loading');
  return el ? { el, label: el.querySelector('span'), note: el.querySelector('.loadnote'), back: $('#loadback') } : null;
}
function entryNote(text, back = false) {
  const p = entryParts(); if (!p || !entry.on) return;
  if (p.note) { p.note.textContent = text; p.note.hidden = false; }
  if (p.back) p.back.hidden = !back;
}
function entryShow(step, progress) {
  const p = entryParts(); if (!p) return;
  clearTimeout(entry.settleTimer); entry.settleTimer = 0; entry.settleRun = null;
  if (entry.settle) { cancelAnimationFrame(entry.settle); entry.settle = 0; }
  setIsoCover(true);   // AC(14.428) — 판이 덮는 동안 쿼터뷰가 굽기 예산을 늘려 보이는 자리를 먼저 끝낸다
  if (p.label) p.label.textContent = step;
  entryProgress(progress);
  p.el.classList.remove('ready'); // R195 — 이미 켜져 있어도 판이 보이게 한다(무엇이 먼저 꺼 버렸든)
  if (entry.on) return;
  entry.on = true; entry.at = performance.now();
  armEntryTimers();
}
function armEntryTimers() {
  clearTimeout(entry.slow); clearTimeout(entry.stuck);
  entry.slow = setTimeout(() => entryNote('평소보다 오래 걸리고 있다. 잠시만 기다려 달라.'), 8000);
  entry.stuck = setTimeout(() => entryNote('응답이 늦다. 아래 버튼으로 처음 화면에 돌아가 다시 입장할 수 있다. 캐릭터 기록은 그대로다.', true), 25000);
}
/**
 * F39(DESIGN 14.539) — 입장 이어받기 대기(503 `field_recovery_pending` — 몸을 쥔 사냥터 층이 격리됐거나 응답이 없다)를 사람이 읽는 줄로.
 * 무슨 일인지 · 안전한지 · 자동 재기동 문장은 서버가 고른 것(`net.js` `recoveryInfo`)을 그대로 쓰고, 여기서는 제목과 진행(다음 확인까지
 * 남은 초 · 기다린 시간 — 1초마다)만 만든다. 전에는 「이전 접속의 상태를 이어받는 중이다」 한 줄이 3~4초마다 되풀이됐고 45초 뒤
 * 「잠시 뒤 다시 입장해 달라」로 끝났다(2026-10-07 실사고). 같은 줄을 입장 판과 끊김 덮개가 쓴다 — 새 창·팝업은 없다(절대규칙 4).
 */
const RECOVERY_HEAD = { quarantined: '사냥터 서버 복구 중', unavailable: '사냥터 서버 응답 없음',
  busy: '사냥터 서버가 몹시 바쁘다', saving: '캐릭터를 불러오는 중…' };
function waitedText(ms) {
  const s = Math.max(0, Math.round(ms / 1000));
  return s < 60 ? `${s}초` : `${Math.floor(s / 60)}분${s % 60 ? ` ${s % 60}초` : ''}`;
}
function recoveryProgress(info, now = performance.now()) {
  // 기다린 시간은 5초부터 붙인다(「0초째」는 진행이 아니다)
  const waited = now - info.since >= 5000 ? ` · ${waitedText(now - info.since)}째 기다리는 중` : '';
  if (info.phase !== 'wait' || !Number.isFinite(info.until)) return `다시 확인하는 중…${waited}`;
  // 격리·응답 없음은 언제 돌아올지 모른다 — 「돌아오면」까지만 말한다(시각을 약속하지 않는다)
  const lead = info.state === 'quarantined' || info.state === 'unavailable' ? '서버가 돌아오면 자동으로 들어간다' : '자동으로 다시 들어간다';
  return `${lead} — ${Math.max(1, Math.ceil((info.until - now) / 1000))}초 뒤 다시 확인${waited}`;
}
const entryWait = { on: false, tick: 0 };
function entryRecovery(info) {
  const p = entryParts();
  clearInterval(entryWait.tick); entryWait.tick = 0;
  const again = $('#loadretry');
  if (!info) {
    if (!entryWait.on) return;
    entryWait.on = false;
    if (again) again.hidden = true;
    if (p?.note) { p.note.textContent = ''; p.note.hidden = true; }
    if (p?.back) p.back.hidden = true;
    if (entry.on) armEntryTimers();   // 이어받은 뒤의 단계(세계·사냥터)도 늦으면 다시 말한다
    return;
  }
  if (!p || !entry.on) return;
  entryWait.on = true;
  clearTimeout(entry.slow); clearTimeout(entry.stuck);   // 「평소보다 오래 걸리고 있다」 대신 까닭과 진행을 말한다
  const draw = () => {
    if (p.label) p.label.textContent = RECOVERY_HEAD[info.state] || RECOVERY_HEAD.saving;
    if (p.note) {
      p.note.textContent = [info.reason, info.safe, info.autoRestart, recoveryProgress(info)].filter(Boolean).join('\n');
      p.note.hidden = false;
    }
  };
  draw();
  if (info.phase === 'wait') entryWait.tick = setInterval(draw, 1000);
  if (p.back) p.back.hidden = false;
  if (again) again.hidden = false;
}
/**
 * AC(DESIGN 14.428) — **몸이 섰으면 마을도 서 있게 판을 걷는다.** 전에는 첫 상태에서 곧바로 판을 걷어, 굽기 전 바닥 조각·옛 도트
 * NPC·차례로 튀어나오는 건물이 눈앞에서 조립됐다. 이제 성공으로 판을 걷는 자리(첫 상태·넘기기 끝)는 쿼터뷰가 보이는 청크를 다 굽고
 * 가까운 몸의 새 도트가 설 때까지(`isoSceneReady`) 기다린다 — 적어도 두 프레임, 길어야 `ISO_COVER_MAX_MS`. 탑다운이면 곧바로 걷는다.
 * 기다리는 동안 다시 판을 띄우는 일(`entryShow` — 사냥터 넘기기 등)이 오면 기다림을 거둔다.
 */
/**
 * UI2a(DESIGN 14.441) — **상한은 판이 뜬 때부터 센다.** 새 도트·예열은 부트 즉시(판이 뜨기 전부터) 받고 굽기 시작하므로, 연결을 기다린 시간이
 * 이미 그림을 기다린 시간이다. 첫 상태 뒤 더 기다리는 상한 = 판이 뜬 뒤 `ENTRY_COVER_TOTAL_MS` 까지 남은 시간(최소 `ISO_COVER_MIN_MS`,
 * 최대 `ISO_COVER_MAX_MS`). 연결이 빨랐으면 전처럼 1.8초까지 기다리고, 연결이 이미 길었으면 0.5초 안에 걷는다 — 판 때문에 늘어나는 입장
 * 시간이 사실상 없다. 다 섰으면(`isoSceneReady`) 그 전에 걷는 것은 그대로다.
 */
const ENTRY_COVER_TOTAL_MS = 3200, ISO_COVER_MIN_MS = 500;
function entryReady() {
  if (!entry.on) { entryDone(); return; }
  if (entry.settle || entry.settleTimer) return;
  entryProgress(0.92); // 묶음 AA — 첫 상태가 왔다: 남은 것은 마을 그림을 굽는 한두 프레임뿐이다
  const t0 = performance.now();
  const capMs = Math.max(ISO_COVER_MIN_MS, Math.min(ISO_COVER_MAX_MS, (entry.at || t0) + ENTRY_COVER_TOTAL_MS - t0));
  const run = entry.settleRun = {};
  // 첫 상태는 이미 왔다. 그림 프레임이 멎어도 기존 그림 대기 상한을 지킨다.
  entry.settleTimer = setTimeout(() => { if (entry.on && entry.settleRun === run) entryDone(); }, capMs);
  let frames = 0, need0 = 0;
  const tick = () => {
    if (!entry.on || entry.settleRun !== run) return;
    entry.settle = 0;
    // ARV1 — 쿼터뷰가 아직 한 프레임도 안 그렸으면(첫 상태 직후 넘기 덮개·지형 대기) 「다 섰다」로 치지 않는다. `isoSceneReady` 는 쿼터뷰가
    // 안 켜져 있으면 참이라, 입장이 빨라지자(GPU 읽기 멈춤 수리) 판이 첫 쿼터뷰 프레임보다 먼저 걷혀 사냥터 땅을 평소 굽기 예산(1.5~6ms)으로
    // 몇 초씩 빈 채 채웠다(헤드리스 하네스 A/B). 쿼터뷰는 몸이 있으면 늘 켜진다(`isoSupportedAt`) — 상한(capMs)은 그대로다.
    if ((++frames > 2 && isoView.active && isoSceneReady()) || performance.now() - t0 >= capMs) { entryDone(); return; }
    // UI2a(14.441) — 기다리는 동안 막대가 멈춰 보이지 않게: 남은 청크·몸이 줄어드는 만큼(또는 상한까지의 시간만큼) 0.92 → 0.99
    const a = isoArtState(), left = (a.left || 0) + (a.units || 0);
    need0 = Math.max(need0, left);
    entryProgress(0.92 + 0.07 * Math.min(1, Math.max(need0 ? 1 - left / need0 : 0, (performance.now() - t0) / capMs)));
    entry.settle = requestAnimationFrame(tick);
  };
  entry.settle = requestAnimationFrame(tick);
}
function entryDone() {
  const p = entryParts();
  clearTimeout(entry.settleTimer); entry.settleTimer = 0; entry.settleRun = null;
  if (entry.settle) { cancelAnimationFrame(entry.settle); entry.settle = 0; }
  setIsoCover(false);
  clearTimeout(entry.slow); clearTimeout(entry.stuck);
  clearInterval(entryWait.tick); entryWait.tick = 0; entryWait.on = false;
  const again = $('#loadretry'); if (again) again.hidden = true;
  if (!entry.on || !p) { entry.on = false; return; }
  entry.on = false;
  p.el.classList.add('ready');
  entryProgress(null);
  if (p.label) p.label.textContent = '게임을 불러오는 중…';
  if (p.note) { p.note.textContent = ''; p.note.hidden = true; }
  if (p.back) p.back.hidden = true;
}
$('#loadback')?.addEventListener('click', () => {
  cancelStart(); cancelDialogs(); endQuietStart({ notify: false }); disconnect({ leave: true }); entryDone(); backToSelect();
});
// F39 — 이어받기 대기 중 다음 확인을 기다리지 않는다(새 버튼은 `?.` — 옛 index.html 이 캐시에 남아도 모듈 평가가 죽지 않게)
$('#loadretry')?.addEventListener('click', () => { retryNow(); });

/** 캐릭터 선택 / 생성 어느 쪽이든 여기로 들어온다 */
async function enter(charId, name, klass2, classChange = false, opts = {}) {
  // 시작 버튼의 사용자 활성화가 살아 있는 동기 구간에서만 브라우저 오디오를 열 수 있다.
  // 접속 응답을 기다린 뒤 열면 첫 이동/클릭을 한 번 더 요구하게 된다.
  if (soundOn()) unlock();
  loadGameFonts();   // 묶음 CL1 — 입장 판이 덮는 동안 게임 안 원본 글꼴을 받는다(첫 화면은 부분집합만 받았다)
  const btn = $('#go');
  btn.disabled = true; btn.textContent = '접속 중…'; $('#err').textContent = '';
  // R187 — 누른 캐릭터 버튼이 바로 말하고, 두 번 누르기를 막는다(전에는 목록 버튼이 그대로라 반응이 없어 보였다)
  const slotBtns = [...document.querySelectorAll('#slots [data-enter]')];
  const slotBtn = charId ? slotBtns.find((b) => b.dataset.enter === charId) : null;
  slotBtns.forEach((b) => { b.disabled = true; });
  if (slotBtn) slotBtn.textContent = '입장 중…';
  entryShow('캐릭터를 불러오는 중…', 0.45);
  window.__unigeHold = ''; // 묶음 AA — 부트 전 누름·재입장 대기를 이 입장이 이어받았다
  // AC(14.428) — 판이 떠 있는 동안 새 도트 목록·내 몸·마을 NPC 를 받기 시작한다. UI2a(14.441) — 돌아온 몸은 누른 슬롯의 직업으로 부른다
  // (전에는 직업을 안 넘겨 내 몸을 첫 프레임에야 불렀다) · 새 몸이면 첫 걸음 몬스터도
  prefetchIsoArt(klass2 || slotBtn?.dataset.klass || null, null, { starter: !charId });
  try {
    // F39 — 이어받기 대기(격리된 층 등)는 이 판이 까닭과 진행을 말하며 기다린다(`entryRecovery`)
    const started = await start(name, klass2, charId, classChange, { ...opts, onWait: entryRecovery });
    // R190 — 세션 이어 쓰기로 붙는 중이면 기억해 둔다: 거절되면(세션이 바뀜) 곧바로 세션 교체 입장으로 넘어간다
    entry.resumed = !!started?.resumed; entry.charId = started?.charId || charId;
    // R195 — 세션 이어 쓰기(새로고침·배포 재입장·10분 안 재입장)는 「이어서」라고 말한다
    entryShow(entry.resumed ? '이어서 들어가는 중…' : '세계에 들어가는 중…', 0.62);
    $('#start').style.display = 'none';
    $('#game').style.display = 'block';
    boot();
  } catch (e) {
    entryDone();
    slotBtns.forEach((b) => { b.disabled = false; });
    if (slotBtn) slotBtn.textContent = '입장';
    btn.disabled = false; btn.textContent = '게임 시작';
    if (e.name === 'AbortError') return;
    $('#err').textContent = e.message || '입장하지 못했다. 잠시 뒤 다시 시도해 달라.';
  }
}
$('#go').onclick = () => {
  const selected = document.querySelector('.klass button.on')?.dataset.k || klass;
  klass = selected;
  enter(null, $('#nm').value, selected, createStartOptions(selected).classChange);
};
/**
 * 세션이 밀렸을 때의 나갈 길 — **새 세션을 받아 이 창에서 이어 한다.**
 * `start(…, charId)` 를 다시 부르면 서버가 세션을 새로 발급하므로, 그다음 연결은
 * 밀리지 않는다. 새로고침을 강요하지 않는 것이 요점이다.
 */
$('#linkgo').onclick = async () => {
  const b = $('#linkgo');
  b.disabled = true; b.textContent = '다시 시작하는 중…';
  try {
    // R190 — 밀려난 세션을 다시 이어 쓰지 않는다. F39 — 이어받기 대기는 이 덮개가 까닭과 진행을 말한다(`linkRecovery`)
    await start(null, null, S.charId, false, { noResume: true, onWait: linkRecovery });
    connect();
  } catch (e) {
    if (e.name === 'AbortError') return;
    $('#linkmsg').textContent = e.message || '재접속에 실패했다. 잠시 뒤 다시 시도해 달라.';
    linkButtons({ go: true, home: true });
  } finally { b.disabled = false; b.textContent = '여기서 다시 시작'; }
};
/**
 * F39(DESIGN 14.539) — 끊김 덮개가 입장 이어받기 대기를 말한다([여기서 다시 시작]). 덮개의 보통 끊김 문구(`renderDrop`)는 이 동안
 * 덮어쓰지 않는다. 사냥터 안 격리는 이 길이 아니다 — net.js 가 같은 사냥터로 다시 붙고(F38 14.538) 덮개는 `renderDrop` 이 말한다.
 */
const linkWait = { on: false, tick: 0 };
function linkRecovery(info) {
  clearInterval(linkWait.tick); linkWait.tick = 0;
  if (!info) {
    // 기다림이 끝났다(들어감 · 실패 · 취소). 멈춘 초읽기를 남기지 않는다 — 들어가면 다음 연결 알림이, 실패면 부른 쪽이 이 줄을 바꾼다
    if (linkWait.on) {
      linkWait.on = false;
      $('#linkhead').textContent = '다시 연결하는 중';
      $('#linkmsg').textContent = '다시 들어가는 중…';
      $('#linknote').textContent = '';
      linkButtons({ home: true });
    }
    return;
  }
  const box = $('#link'); if (!box) return;
  linkWait.on = true;
  box.classList.add('on'); box.classList.remove('quiet');
  const draw = () => {
    $('#linkhead').textContent = info.state === 'saving' ? '캐릭터를 데려오는 중' : RECOVERY_HEAD[info.state] || RECOVERY_HEAD.unavailable;
    $('#linkmsg').textContent = [info.reason, info.safe].filter(Boolean).join('\n');
    $('#linknote').textContent = [info.autoRestart, recoveryProgress(info)].filter(Boolean).join('\n');
  };
  draw();
  if (info.phase === 'wait') linkWait.tick = setInterval(draw, 1000);
  linkButtons({ retry: true, home: true });
}
/**
 * R198 — 다음 재시도(최대 8초)를 기다리지 않고 지금 잇는다. 이미 잇는 중이면 그대로 둔다.
 * (새 버튼은 `?.` 로 붙인다 — 옛 index.html 이 캐시에 남아도 모듈 평가가 죽지 않게)
 */
$('#linkretry')?.addEventListener('click', () => {
  if (S.connected) return;
  retryNow();
  if (!linkWait.on) $('#linkmsg').textContent = '다시 연결하는 중…';   // F39 — 이어받기 대기면 그 줄(`linkRecovery`)이 「다시 확인하는 중」을 말한다
});
/** R198 — 끊긴 채로 캐릭터 선택으로 나간다(하단 「나가기」는 덮개 아래에 있다). 캐릭터 기록은 서버에 그대로다 */
$('#linkhome')?.addEventListener('click', () => {
  cancelStart();
  cancelDialogs();
  endQuietStart({ notify: false });
  storyIntro.close({ welcome: false });
  hallCard.close();
  disconnect({ leave: true }); closePanel(); S.you = null; setMusicScene('title');
  $('#link').classList.remove('on'); linkButtons(); hideFieldShift();
  backToSelect();
});
$('#back').onclick = () => { cancelStart(); cancelDialogs(); endQuietStart({ notify: false }); disconnect({ leave: true }); backToSelect(); };
/**
 * Google 전환이 플레이 중 일어나면 화면의 몸과 localStorage 계정이 갈린다.
 * 같은 계정 첫 연결은 그대로 두되, 다른 Google 계정 복구(`restored`)는 옛 소켓을 닫고
 * 캐릭터 선택으로 돌아간다. 서버가 두 계정을 합치지 않는 것만큼 화면도 둘을 섞지 않는다.
 */
const authChanged = async (result) => {
  if (result?.restored) {
    resetAdminForIdentitySwitch();
    cancelStart();
    cancelDialogs();
    endQuietStart({ notify: false });
    storyIntro.close({ welcome: false });
    hallCard.close();
    // The socket/native handoff may exist before the first state packet sets S.you.
    disconnect({ leave: true }); closePanel(); S.you = null;
    setMusicScene('title'); backToSelect();
    return;
  }
  await refreshSelect();
};
// 옛 주소의 초대 링크를 정식 주소로(DESIGN 14.451) — 주소 변경 안내 카드·계정 이전은 걷어냈다(14.596)
addEventListener('unige:domain-rollout', () => { if (S.panel === 'help') renderPanel(true); });
void initDomainRollout();
// OAuth 복귀 중에는 옛 계정으로 캐릭터를 먼저 조회하거나 시작하지 않는다.
async function initAccountAccess() {
  $('#go').disabled = true;
  await finishNaverAuth();
  // 팝업이 막혀 같은 창으로 다녀온 Google 로그인 중계(DESIGN 14.448)도 첫 캐릭터 조회 전에 새 열쇠로 바꾼다.
  await finishGoogleRelay();
  initSelect(enter);
  $('#go').disabled = false;
  // 묶음 AA(DESIGN 14.431) — 모듈보다 먼저 누른 [게임 시작] 을 이어서 누른다(새 캐릭터 폼이 보일 때만 — 계정이 있는 기기는 폼이 없다)
  if (window.__unigeHold === 'go') {
    window.__unigeHold = '';
    if (!S.you && $('#create')?.style.display !== 'none') $('#go').click();
    else { $('#go').textContent = '게임 시작'; revealPage(); }
  }
  const auth = Promise.allSettled([initGoogleAuth(authChanged), initNaverAuth(authChanged)])
    .then((rs) => { for (const r of rs) if (r.status === 'rejected') console.error('[auth:init]', r.reason); });
  /**
   * UNI-Q172 — 배포 새로고침이면 **로그인 초기화를 기다리지 않고** 곧장 같은 캐릭터로 들어간다.
   *
   * 초기화 뒤에 두면 배포 직후 네이버 상태 조회가 한 번만 실패해도(`initNaverAuth` 는 던진다)
   * 복귀가 통째로 건너뛰어지고, 구글 스크립트가 늦으면 그만큼 늦는다 — 켜 두고 자는 사람은 아침까지
   * 로비에 선다. 초기화가 복귀를 흔드는 길(`authChanged` 의 계정 전환)은 사용자가 직접 다른 구글
   * 계정으로 로그인해야만 열리므로 자동 복귀와 겹치지 않는다. 캐릭터가 이 계정 것이 아니면 서버가
   * start 에서 거절하고, 선택 화면(바로 위에서 준비됨)에 그 오류가 뜬다.
   */
  const rejoin = takeRejoin();
  if (rejoin && !S.you) await enter(rejoin, null, null);
  else if (window.__unigeHold === 'rejoin') releaseHold();
  await auth;
}
void initAccountAccess();
addEventListener('unige:auth-status', () => {
  if (S.panel === 'account') renderPanel(true);
});
// `auth.js`가 localStorage를 지우고 새로고침하기 직전, 살아 있는 몸부터 정상 종료한다.
addEventListener('unige:auth-device-logout', () => {
  cancelStart();
  cancelDialogs();
  endQuietStart({ notify: false });
  storyIntro.close({ welcome: false });
  hallCard.close();
  disconnect({ leave: true }); closePanel(); S.you = null; setMusicScene('title');
});
/**
 * 관리 화면 배선은 **`boot()` 밖**이다.
 *
 * `boot()` 은 **게임에 들어간 뒤에만** 돈다. 그 안에 두면 `#admin` 이
 * **캐릭터 선택 화면에서 안 열린다** — 관리하려고 들어왔는데 먼저 게임에
 * 접속해야 하는 셈이다. 이 화면이 필요한 건 **토큰뿐**이고, 게임 접속이
 * 필요한 건 `goto` 하나다(옮길 몸이 있어야 한다 — 그건 서버가 말해준다).
 *
 * 나가는 길은 `adminview.js` 가 자기가 갖는다 — 여는 쪽과 닫는 쪽이 갈라지면
 * 하나만 고쳐진다.
 */
wireAdmin();
/**
 * **안 읽은 소식 배지.** `boot()` 안이 아니라 여기서 부른다 — `boot()` 는 게임에
 * 들어간 뒤에만 도는데, 배지는 **캐릭터 고르는 화면에서도 탭이 있으면** 맞아야 한다.
 * (`wireAdmin` 을 여기 둔 것과 같은 이유다.)
 */
syncNewsBadge();

// ── 부팅 ─────────────────────────────────────────────────────────
let booted = false;
function boot() {
  if (booted) { connect(); return; }
  booted = true;
  initScene($('#cv'));
  initQuality();
  // P7 V1 — 낮음 단계는 GPU 층을 아예 안 켜서 오늘의 Canvas2D 렌더러 비용 그대로 남는다
  // (render/quality.js 상단 설명). 세션 도중 실측으로 낮음까지 내려가도 이미 켠 층은
  // 그대로 둔다 — 여기서 한 번만 확인한다.
  if (shouldInitGpuLayers()) void initGpuScene();
  initMini($('#mini'));
  initInput($('#cv'));
  bindIsoZoomWheel($('#cv'));   // UI2a(14.441) — PC 시야 단계: 화면 위 휠
  initTopLane();                // UI2a — 위쪽 가운데 알림 줄(이야기·넘기기·다시 잇는 중·공지가 겹치지 않게)
  initChat();
  // 채팅 입력을 만든 뒤 기록 서랍을 잇는다 — 채팅 탭의 [말하기]가 같은 입력창을 연다.
  // 키보드가 없는 폰의 채팅 문이다(Q276 — 전에는 [더보기]의 [채팅]도 있었다): [기록] → [말하기]
  initFeed();
  $('#feedtalk').onclick = () => toggleChat();
  // 첫 입력과 OS가 오디오를 다시 중단한 뒤의 입력에서만 재개한다.
  ['pointerdown', 'keydown', 'touchstart'].forEach((e) =>
    addEventListener(e, resumeSoundAfterInterruption, { passive: true }));
  wireUi();
  wireNet();
  connect();
  (function loop() { requestAnimationFrame(loop); draw(true); crossingTick(); })(); // C3(14.476) — 화면 갱신마다 그린다(상한 없음 · 입장 덮개 동안의 쉼만 scene.js drawHold) · C9 — 넘는 칸에 닿았나(30ms 마다)
  // 첫 안내는 서버 init 뒤 showIntro 하나가 맡는다. 도움말은 ? / 길잡이로 연다.
}

/** 사망 화면 자동 닫기 타이머. 연속 사망 시 앞 타이머가 뒤 화면을 닫는 것을 막는다 */
let deadTimer = null;

function wireUi() {
  // 사망 화면은 시야를 통째로 덮는다. 다 읽었으면 기다리지 않고 닫을 수 있어야 한다
  $('#dead').onclick = () => { clearTimeout(deadTimer); $('#dead').classList.remove('on'); };
  /**
   * **덮개 바깥을 눌렀을 때 아무 일도 안 하면, 그건 고장으로 읽힌다.**
   *
   * `#link` 는 `inset:0` · `pointer-events:auto` 라 **모든 클릭을 삼킨다.** 그런데
   * 반투명이라 **세계가 그대로 비쳐 보인다** — 사용자는 보이는 세계를 클릭하고,
   * 그 클릭은 덮개가 먹고, 화면은 아무 말도 안 한다. 증상은 정확히
   * *"게임은 보이는데 캐릭터가 안 움직인다"* 이고 **콘솔 에러는 0건**이다.
   *
   * ⚠ **닫지는 않는다.** `#world-story` 는 바깥을 누르면 닫히지만 저건 읽고 넘기는
   * 창이고, 이건 **연결이 실제로 끊긴 상태**다. 닫으면 만질 수 없는 세계만
   * 보여주게 되어 더 나쁘다. **닫는 대신 나가는 길을 가리킨다.**
   *
   * 오늘 과적 P0 의 교훈과 같은 자리다 — **막혔는데 아무 말이 없으면 사용자가
   * 자기를 의심한다.**
   */
  const linkBox = $('#link');
  linkBox.onclick = (e) => {
    if (e.target !== linkBox) return;          // 상자·버튼을 누른 것은 그쪽 몫이다
    const shown = ['#linkgo', '#linkretry', '#linkhome'].some((id) => { const b = $(id); return b && b.style.display !== 'none'; });
    $('#linknote').textContent = !shown
      ? '연결이 끊겨 있다. 이어지면 이 창은 저절로 사라진다.'
      : '이 창이 떠 있는 동안에는 화면을 눌러도 움직이지 않는다. 아래 버튼을 눌러 달라.';
    linkBox.classList.remove('nudge');
    void linkBox.offsetWidth;                  // 연속 클릭에도 애니메이션이 다시 돈다
    linkBox.classList.add('nudge');
  };
  $('#b-pot').onclick = usePotion;
  $('#b-scroll').onclick = () => send({ t: 'scroll' });
  initActionDock();
  initAttackButton();
  initScrollCue();
  /**
   * Q276(사용자 결정 2026-10-13 B안) — **늘 보이는 다섯 칸**: 가방 · 스킬 · 지도 · 행사 · 메뉴.
   * PC 는 왼쪽 세로줄, 폰은 행동 칸 옆 같은 한 줄이다(Q299 · 같은 버튼 — index.html `#mainbar`). 지도는 창이 아니라 전체 지도를 연다.
   * 전에는 PC 도구열 9칸·창 위 탭 줄 13칸·[더보기] 팔레트에 같은 문이 세 벌이었다.
   */
  document.querySelectorAll('#mainbar button[data-m]').forEach((b) => {
    b.onclick = () => (b.dataset.m === 'map' ? toggleWorldMap() : togglePanel(b.dataset.m));
  });
  // [‹ 메뉴] — 메뉴에서 연 창(또는 마을 NPC 가 연 창)에서 메뉴 한 화면으로
  $('#pback').onclick = () => togglePanel('menu', true);
  $('#pnavtoggle').onclick = () => {
    const open = $('#panel').classList.toggle('nav-open');
    $('#pnavtoggle').setAttribute('aria-expanded', String(open));
  };
  // UNI-Q110 ① — 마을 맥락 버튼 셋. 어느 것을 보일지는 hud.js 가 자리(where)로 정한다.
  $('#b-shop').onclick = () => togglePanel('shop');
  $('#b-forge').onclick = () => togglePanel('forge');
  $('#b-vault').onclick = () => togglePanel('vault');
  // Q276 — 강공은 [자동] 위 작은 창의 셋째 칸(전에는 [더보기] 팔레트). PC 는 A 키·Ctrl+클릭 그대로
  $('#b-force').onclick = (ev) => { ev.stopPropagation(); setForce(!S.forceMode); };
  // ADS-BOOST-R1 — 광고 부스트는 Q276 부터 메뉴 화면의 「광고 보상」 줄(panels/menu.js · act.adBoost). 켬끔이 바뀌면 메뉴를 다시 그린다
  addEventListener('unige:ads-status', () => { if (S.panel === 'menu') renderPanel(true); });
  on('nativeTransition', () => { if (S.panel === 'menu') renderPanel(); });
  // 모의 공성전 모집 창의 [행사에서 보기]
  addEventListener('unige:events', (e) => openEvents(e.detail));
  $('#b-auto').onclick = (ev) => {
    ev.stopPropagation();
    const actions = $('#actions'), menu = $('#auto-more');
    const open = !actions.classList.contains('auto-open');
    actions.classList.toggle('auto-open', open);
    if (menu) menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  };
  $('#b-auto-toggle').onclick = (ev) => { ev.stopPropagation(); send({ t: 'autoToggle' }); };
  $('#b-retaliate-toggle').onclick = (ev) => { ev.stopPropagation(); send({ t: 'autoRetaliate', on: !(S.you?.inv?.autoRetaliate === true) }); };
  /**
   * UNI-Q179 — 첫 걸음 목표 줄. 「보상 받기」는 서버에 한 번만 보내고(응답·다음 상태 틱이 줄을 바꾼다),
   * 줄의 나머지를 누르면 서버가 준 길잡이 문장을 기록에 띄운다. 목표 판정은 서버만 한다.
   */
  // UNI-Q186 — 공성전 한 줄을 누르면 [행사] › 공성전(신청·입장·나가기는 거기서 — Q276 전에는 길드 창 「공성전」 탭)
  $('#siegehud')?.addEventListener('click', () => openEvents('siege'));
  $('#goalline')?.addEventListener('click', (e) => {
    if (e.target.closest('[data-goal-map]')) { openWorldMapAt(goalAimRaw()?.field); return; }
    if (e.target.closest('[data-goal-clear]')) { clearGoalAim(); syncHud(); return; }
    if (e.target.closest('.goal-purpose')) return;
    const toggle = e.target.closest('.goal-toggle');
    if (toggle) {
      const expanded = $('#goalline').classList.toggle('expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', `${toggle.dataset.goalNextToggle === '1' ? `다음 목표 ${toggle.dataset.goalNextLabel} · 행동` : '목표 상세'} ${expanded ? '접기' : '펼치기'}`);
      toggle.querySelector('span').textContent = expanded ? '⌃' : '⌄';
      return;
    }
    if (nativeFieldGeometry()) send({ t: 'fieldGoalsGet' });
    const g = S.you?.firstStep;
    // UNI-Q180 — today's goals share the line after the first steps: the button claims, the rest asks the server
    // for the list and a direction. Goals and progress are judged only by the server.
    const d = !g ? S.you?.daily : null;
    if (d) {
      const online = S.connected && S.ws?.readyState === 1;
      if (e.target.closest('[data-daily-claim]')) {
        if (S.goalClaimBusy || !online) return;
        sendGoalClaim({ t: 'dailyClaim' });
        return;
      }
      if (online) { followSuggestedGoal(); send({ t: 'dailyHint' }); }
      else log(`오늘의 목표 — ${d.goals.map((x) => `${x.text} ${x.progress}/${x.n}`).join(' · ')}`, 'info');
      return;
    }
    if (!g) return;
    if (e.target.closest('[data-first-boss-start]')) {
      if (!g.done && g.id === 'boss' && S.connected && S.ws?.readyState === 1) {
        followSuggestedGoal();
        const field = nativeFieldGeometry()?.fieldId;
        if (field && field !== 'surface:field') {
          send({ t: 'firstStepHint' });
          log('들판에서 「보스에게 도전」을 누르면 첫 보스전을 시작할 수 있다.', 'info');
        } else requestFirstBossStart();
      }
      return;
    }
    if (e.target.closest('[data-goal-claim]')) {
      if (S.goalClaimBusy || !S.connected || S.ws?.readyState !== 1) return;
      sendGoalClaim({ t: 'firstStepClaim', id: g.id });
      return;
    }
    // 이미 여기서 할 수 있는 첫 걸음은 실제 물약/강화 창을 연다. 멀리 있으면 아래 서버 길잡이를 그대로 쓴다.
    if (!g.done && S.connected && S.ws?.readyState === 1) {
      const panel = g.id === 'potion' ? 'potion' : g.id === 'enhance' ? 'forge' : null;
      const need = g.id === 'potion' ? 'buy' : g.id === 'enhance' ? 'enhance' : null;
      if (panel && canAct(where(S.you), need, S.you)) {
        if (panel === 'forge' && S.you.inv?.equipped?.weapon) S.forgeSel = [S.you.inv.equipped.weapon];
        togglePanel(panel, true);
        return;
      }
    }
    // 방향(가장 가까운 약한 몬스터·상인·대장장이·보스)은 서버가 몬스터·NPC 자리에서 계산해 기록으로 답한다.
    // 연결이 끊겨 있으면 받은 문장만 띄운다.
    if (S.connected && S.ws?.readyState === 1) { followSuggestedGoal(); send({ t: 'firstStepHint' }); }
    else log(`길잡이 — ${g.hint}`, 'info');
  });
  /*
   * 묶음 GD1(14.465) — 새 목표가 열리면(첫 걸음 다음 칸 · 오늘의 목표 다음 칸) 길잡이를 **한 번** 저절로 묻는다 — 서버가 문장과 함께 자리(`goalAim`)를
   * 주면 땅 위 화살표·미니맵 별·지도 표식이 곧장 선다(누르지 않아도). 같은 목표는 접속마다 한 번만, 다 채운 목표(보상 받기)는 묻지 않는다.
   */
  let askedGoal = '';
  on('state', () => {
    if (goalGuideMode() !== 'suggested') return;
    const key = goalKeyOf(S.you);
    if (!key || key === askedGoal || key.endsWith(':1') || !S.connected || S.ws?.readyState !== 1) return;
    askedGoal = key;
    if (nativeFieldGeometry()) send({ t: 'fieldGoalsGet' });
    send({ t: S.you?.firstStep ? 'firstStepHint' : 'dailyHint' });
  });
  // 채팅은 Enter 로만 열렸다 — 키보드가 없는 모바일에선 [기록] → [말하기](위 initFeed 곁의 배선)가 그 문이다.
  // Q276 — 소리 켜기·끄기는 메뉴 › 시스템 › 설정의 「소리」 한 곳(M 키는 지도로 옮겼다 — 전에는 소리가 네 곳이었다)
  const leaveToSelect = () => {
    cancelStart();
    cancelDialogs();
    endQuietStart({ notify: false });
    storyIntro.close({ welcome: false });
    hallCard.close();
    disconnect({ leave: true }); closePanel(); S.you = null; setMusicScene('title'); backToSelect();
    // 플레이를 끝내고 선택 화면으로 돌아온 뒤라 캐릭터가 광고 중 공격받지 않는다.
    void showInterstitial('leave_game');
  };
  // R166 — 나가기 확인도 도트 확인 창이 묻는다(브라우저 창은 게임 화면 위에서 다른 프로그램처럼 뜬다)
  const doLogout = () => askConfirm('나가면 캐릭터 선택으로 돌아간다. 진행 상황은 저장돼 있다.', leaveToSelect, { ok: '나가기' });
  // Q276 — 나가기는 메뉴 › 시스템 › 나가기(act.menuOpen → unige:logout)와 계정 창의 [캐릭터 선택](act.logout)이 부른다
  addEventListener('unige:logout', doLogout);
  $('#pclose').onclick = closePanel;
  addEventListener('unige:panel', (e) => togglePanel(e.detail, true));
  addEventListener('unige:milestone-map', (e) => openWorldMapAt(e.detail));
  addEventListener('unige:key', (e) => {
    const k = e.detail;
    if (k === 'enter') { toggleChat(); return; }
    if (chatOpen()) return; // 입력 중에는 단축키를 삼킨다
    if (k === 'q') usePotion();
    else if (k === 'r') send({ t: 'scroll' });
    else if (k === 'i') togglePanel('inv');
    else if (k === 't') togglePanel('shop');
    else if (k === 'h') togglePanel('help');
    // UNI-Q110 ⑥ — PC 도구열이 보여 주는 단축키. 글자는 도구열 힌트와 같은 한 벌이다.
    else if (k === 'k') togglePanel('skills');
    else if (k === 'f') togglePanel('forge');
    else if (k === 'v') togglePanel('vault');
    else if (k === 'l') togglePanel('rank');
    else if (k === 'n') togglePanel('dex');
    else if (k === 'o') togglePanel('settings'); // UNI-Q173 — 설정(Options)
    else if (k === 'e') togglePanel('events'); // Q276 — 행사(Events): 공성전·모의 공성전·시련의 탑·현상금·공지
    else if (k === 'escape') { closePanel(); send({ t: 'untarget' }); }
    else if (k === '-' || k === '=' || k === '+') { const dir = k === '-' ? -1 : 1; announceStep(dir, isoZoomStep(dir)); } // UI2a — 시야 멀리·가까이(끝이면 그렇다고 말한다)
    else if (k === 'm') toggleWorldMap(); // Q276 — 지도(Map). 소리 켜기·끄기는 설정의 「소리」로 옮겼다
    else if (['1', '2', '3', '4', '5', '6'].includes(k)) castSkill(Number(k) - 1); // R212 — 식는 중이면 시전음 대신 거절음(skillbar.js)
  });
}

/** Q276 — [행사] 창이 그 칸을 보이고 있는가(공지·현상금·모의 공성전·공성전·탑 회신이 다시 그릴 때만 본다) */
const eventTabShown = (tab) => S.panel === 'events' && S.eventTab === tab;

function usePotion() {
  if (!S.you) return;
  const c = S.you.inv.consum || {};
  const id = (c.pot_m > 0) ? 'pot_m' : (c.pot_s > 0) ? 'pot_s' : null;
  if (!id) { log('물약이 없다. 마을 물약상인에게서 구매해 달라.', 'bad'); return; }
  send({ t: 'use', id });
}

/** STORY-R1 replaces the 2026-08-31 fullscreen #intro click trap.
 * Its outer box never catches input. First game input passes through; storage is marked on show.
 * Detailed rules remain in help. No tutorial progress, player state, or network messages change.
 */
const entered = new Set();
/** R200 — 이 화면이 이미 보인 공지: 원천 `init` 목록(`시각|문장`) · 실시간 방송(문장, 최근 40) */
const annShown = new Set();
const annLive = [];
const storyIntro = createStoryIntro({
  root: $('#world-story'), arrival: $('#story-arrival'),
  onArrival: (text) => log(esc(text)),
  focusGame: () => $('#cv')?.focus({ preventScroll: true }),
});
/** UNI-Q193 — 새 세계 첫 입장 카드(지난 세계의 명예의 전당). 서버가 보낼 때만 뜨고 게임을 막지 않는다. 스토리 카드와 겹치지 않는다 */
const hallCard = createHallCard({
  // R126 — 첫 입장 30초(스토리 카드·다음 목표만) 동안에도 기다렸다가 뜬다
  root: $('#hall-card'), storyOpen: () => !!$('#world-story.on') || quietStart(), onOpen: () => togglePanel('hall', true),
});
/**
 * R126 — 첫 입장 이야기 카드 + 30초 조용한 창. 세로 폰이면 「가로로 돌려 달라」(Q3 C안)가 게임을 통째로 덮는다 —
 * 그 뒤에서 9초 이야기와 30초 창이 흘러가 버려 **아무도 이야기를 못 봤다**. 덮개가 걷힌 뒤(돌렸거나 「세로로 계속」)에 연다.
 * 덮개는 쿼터뷰 첫 프레임이 만들므로 한 박자(0.4초) 뒤에 본다. 3분을 넘기면 기다리지 않는다.
 */
function introWhenVisible(cid, waited = 0) {
  setTimeout(() => {
    if (!S.you || (S.charId || '') !== cid) return;
    if (landscapeHintShown() && waited < 180_000) { introWhenVisible(cid, waited + 500); return; }
    if (showIntro()) beginQuietStart();
  }, waited ? 500 : 400);
}
function showIntro(replay = false) {
  if (!S.you || S.you.dead) return false;
  return storyIntro.show({ charId: S.charId, world: S.world, replay,
    guideName: NPCS.find((npc) => npc.id === 'guide')?.name || '마을 사람',
    lines: arrivalLines(), welcomeTail: arrivalOffering() });
}
// Delegation survives help panel redraws without binding a second click path.
document.addEventListener('click', (event) => {
  if (!event.target.closest?.('[data-story-replay]') || !S.you) return;
  closePanel(); showIntro(true);
});

let panelRenderAt = 0;
let panelRenderTimer = 0;
function renderPanelFromState() {
  if (!S.panel) return;
  const now = performance.now(), wait = Math.max(0, 250 - (now - panelRenderAt));
  if (wait === 0) { panelRenderAt = now; renderPanel(); return; }
  if (panelRenderTimer) return;
  panelRenderTimer = window.setTimeout(() => {
    panelRenderTimer = 0;
    if (S.panel) { panelRenderAt = performance.now(); renderPanel(); }
  }, wait);
}
function wireNet() {
  let nativeGoals = null;
  let goalsRefreshRequested = '', goalsRefreshAt = 0, goalsRefreshTries = 0;
  const currentGoalKey = () => {
    const field = nativeRegionId();
    if (!field || !S.you || !S.world?.n) return '';
    const day = new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);
    return `${S.charId}|${S.world?.n}|${field}|${S.you.level}|${S.you.inv?.firstSteps?.i ?? ''}|${day}`;
  };
  const applyNativeGoals = () => {
    const key = currentGoalKey();
    if (!nativeGoals || !key) return;
    // 묶음 X(T11, DESIGN 14.437) — 목표(첫 걸음·오늘의 목표)는 캐릭터의 것이지 사냥터의 것이 아니다. 사냥터를 옮겨도 새 답(`fieldGoals`)이 올
    // 때까지 옛 답으로 그린다 — 전에는 넘길 때마다 목표 줄·보상 버튼이 비었다가 다시 찼다. 사냥터가 달라진 것은 아래 sourceKey 가 다시 묻는다
    if (nativeGoals.charId !== S.charId || (S.world?.n && nativeGoals.worldN !== S.world.n)) {
      nativeGoals = null;
      return;
    }
    const y = S.you, rule = nativeGoals.firstStepRule;
    let firstStep = nativeGoals.firstStep;
    // R116(H5) — 사냥터가 이제 살아 있는 `kills` 를 보낸다. 입장 이미지에 `inv.firstSteps` 가 아직 없으면
    // (pubSelf 가 인계 캡처 뒤에 만든다) 목표를 준 원천 판정의 기준(`firstStepRule.base`)으로 센다.
    const st = y.inv?.firstSteps ?? (firstStep && rule ? { i: firstStep.i, base: rule.base } : null);
    if (firstStep && rule && st?.i === firstStep.i) {
      const raw = rule.kind === 'kills' ? y.kills - st.base
        : rule.kind === 'level' ? y.level
          : rule.kind === 'enhance' ? Number(y.inv?.equips?.some(e => e.plus >= 1))
            : rule.kind === 'buyPotion' ? Number(!!st.bought) : Number(!!st.boss);
      const progress = Math.max(0, Math.min(firstStep.n, Number.isFinite(raw) ? raw : 0));
      firstStep = { ...firstStep, progress, done: Number(progress >= firstStep.n) };
    }
    let daily = nativeGoals.daily;
    if (daily) {
      const today = new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);
      const current = y.inv?.daily?.day === today ? y.inv.daily : null;
      const got = new Set([...(daily.day === today ? daily.goals.filter(goal => goal.got).map(goal => goal.id) : []),
        ...(daily.day === today && daily.bonusGot ? ['bonus'] : []), ...(current?.got ?? [])]);
      const goals = daily.goals.map(goal => ({ ...goal,
        progress: Math.max(0, Math.min(goal.n, Number(current?.[goal.id] ?? 0))),
        got: Number(got.has(goal.id)) }));
      const allDone = goals.every(goal => goal.got || goal.progress >= goal.n);
      const ready = goals.filter(goal => !goal.got && goal.progress >= goal.n);
      const bonusReady = allDone && !got.has('bonus');
      daily = { ...daily, day: today, goals, bonusGot: Number(got.has('bonus')),
        claim: Number(ready.length > 0 || bonusReady),
        claimReward: [...ready.map(goal => goal.reward), ...(bonusReady ? [daily.bonus] : [])].filter(Boolean).join(' · ') };
    }
    y.firstStep = firstStep && nativeGoals.firstStepClaimed
      ? { ...firstStep, reward: '계정 수령 완료' } : firstStep;
    y.daily = firstStep ? null : daily;
    const sourceKey = `${S.charId}|${nativeGoals.worldN}|${nativeGoals.fieldId}|${nativeGoals.level}|${nativeGoals.firstStepIndex ?? ''}|${nativeGoals.day}`;
    // 10-20 운영 — 한 번만 다시 묻던 것을, 답이 아직 몸(새 목표 칸)보다 뒤처져 있으면 3초마다 다시 묻는다. 받은 직후의 읽기가 받기 전
    //   기록을 돌려주면 열쇠가 같아 다시 묻지 않아 목표 줄이 옛 목표(물약 사기 0/1)에 멈췄다(길잡이는 새 목표를 가리킴).
    const nowMs = Date.now();
    // 다시 묻기는 목표 칸이 어긋날 때만(레벨은 D1 저장보다 몸이 먼저 올라 레벨업마다 어긋난다 — 그것으로는 다시 묻지 않는다 · 독립 검토)
    const stepBehind = String(S.you?.inv?.firstSteps?.i ?? '') !== String(nativeGoals.firstStepIndex ?? '');
    if (key !== sourceKey && (goalsRefreshRequested !== key || (stepBehind && nowMs - goalsRefreshAt > 3000 && goalsRefreshTries < 5))) {
      goalsRefreshTries = goalsRefreshRequested === key ? goalsRefreshTries + 1 : 0;
      goalsRefreshRequested = key; goalsRefreshAt = nowMs;
      send({ t: 'fieldGoalsGet' });
    }
  };
  // 월드 상태는 10Hz로 받되, 열린 패널의 무거운 DOM 재구성은 4Hz로 제한한다.
  // HUD·월드 캔버스·전투 판정은 기존 주기를 그대로 유지한다.
  on('state', () => { travelOnState(); applyNativeGoals(); retryPendingGoalClaim(); syncHud(); syncSkills(); watchEvents(); renderPanelFromState(); cueState(); });
  on('fieldGoals', (m) => {
    if (!nativeFieldGeometry() || !S.charId) return;
    nativeGoals = { ...m, charId: S.charId };
    applyNativeGoals();
    syncHud();
  });
  on('goalClaimResult', (m) => {
    if (!nativeFieldGeometry()) return;
    // 묶음 R-B(1.0 대조 10행) — 사냥터 면죄부 구매의 결과. 1.0 처럼 기록창에 한 줄(가격·「죽으면 떨어진다」)과 성공이면 「📜 면죄부 획득」.
    // 목표 수령이 아니라 구매라 싸움 뒤 저절로 다시 보내지 않는다(G9 는 목표에만) — 거절 문장이 이유와 할 일을 말한다.
    if (m.kind === 'pardonBuy') {
      S.pardonBusy = null;
      log(m.message || (m.ok ? '면죄부를 샀다.' : '면죄부를 사지 못했다.'), m.ok ? '' : 'bad');
      toast(m.ok ? '📜 면죄부 획득' : (m.message || '면죄부를 사지 못했다.'), m.ok ? 'good' : 'bad');
      if (m.ok) send({ t: 'bountyList' }); // 창구·수배 목록의 보호 표시를 새로(사냥터는 원천 읽기 길로 간다)
      if (eventTabShown('bounty')) renderPanel(true);
      return;
    }
    // R-A(DESIGN 14.453) — 내가 건 목표가 아니다: 운영 콘솔의 지급·정리(`adminOp`)와 경비병 뇌물(`guardBribe`)은 문장만 보인다
    // (목표 창 새로고침·싸움 뒤 다시 보내기는 목표 수령에만 쓴다 — 여기서 타면 엉뚱한 목표를 다시 보낸다)
    if (m.kind === 'adminOp' || m.kind === 'guardBribe') {
      log(m.message || (m.ok ? '받았다.' : '받지 못했다.'), m.ok ? '' : 'bad');
      if (m.kind === 'adminOp' || !m.ok) toast(m.message || '', m.ok ? 'gear' : 'bad');
      return;
    }
    if (m.kind === 'petRevive') {
      const pending = S.petRevivePending;
      if (pending?.kind === m.id) { clearTimeout(pending.timer); S.petRevivePending = null; }
      toast(m.message || (m.ok ? '펫이 되살아났다.' : '펫을 되살리지 못했다.'), m.ok ? 'gear' : 'bad');
      if (S.panel === 'pets' || S.panel === 'shop') renderPanel(true);
      return;
    }
    releaseGoalClaim();
    // G9 — 전투 중 거절이면 싸움이 끝나는 대로 다시 보낸다. 저절로 다시 보낸 것의 거절은 조용히 넘긴다.
    const pend = S.goalClaimPending;
    if (m.ok) S.goalClaimPending = null;
    else if (lastGoalClaim && S.you?.growthFlow?.claimAfterCombat !== false && isCombatRefusal(m)) {
      const first = !pend;
      if (first) S.goalClaimPending = { msg: lastGoalClaim, since: Date.now(), at: Date.now(), auto: false };
      if (first) toast(`${m.message} — 싸움이 끝나면 저절로 받는다.`, 'bad');
      goalsRefreshRequested = '';
      send({ t: 'fieldGoalsGet' });
      return;
    } else S.goalClaimPending = null;
    toast(m.message || (m.ok ? '보상을 받았다.' : '보상을 받지 못했다.'), m.ok ? 'gear' : 'bad');
    goalsRefreshRequested = '';
    send({ t: 'fieldGoalsGet' });
    // 10-28(사용자 「납득하기 어려운 딜레이를 더 찾아 해결」) — 부동산의 「현재 집으로」·「집에서 나가기」·기본 귀환지·투자도 이 길(목표 수령)로
    //   돌아온다. 전에는 목표만 다시 읽어, 성공 알림이 떠도 부동산 창의 「현재 집」 표시·고른 귀환지가 창을 다시 열 때까지 옛 것이라 또 눌렀다.
    if (typeof m.kind === 'string' && m.kind.startsWith('realty')) send({ t: 'realtyHome' });
    // 10-20 운영(마을 구역) — 받은 직후의 목표 읽기가 받기 전 기록을 돌려줘 목표 줄이 「물약 사기 0/1」에 멈춘 채, 길잡이(새로 읽음)는
    //   다음 목표(대장장이)를 가리켰다. 받은 뒤 두 번 더 읽어 다음 목표로 넘어간다(목표 수령 성공 때만 · 읽기 두 번).
    if (m.ok) for (const ms of [1500, 5000]) setTimeout(() => {
      if (S.connected && nativeFieldGeometry()) { goalsRefreshRequested = ''; send({ t: 'fieldGoalsGet' }); }
    }, ms);
  });
  /**
   * 세계가 닫히면 옛 연결을 끊고 선택 화면으로 돌아간다. UNI-Q130 — 캐릭터는 이름 그대로 1레벨로 초기화돼 남는다.
   * 창고의 보존 여부는 이 세계의 서버 설정에 따르고 도감·집·길드 건물은 남는다. 무엇이 남는지는 도움말 「세계가 끝나면」 표가 정본이다.
   */
  on('worldReset', (m) => {
    // 묶음 Y(14.429, G5) — 끊기 전에 이번 세계의 몸(레벨·처치·가져가는 것)을 결산 카드용으로 잡아 둔다
    const recap = captureWorldRecap(S.you, m.old, S.charId);
    forgetResume(); // R190 — 옛 세계의 세션을 새 세계에서 이어 쓰지 않는다
    cancelDialogs();
    endQuietStart({ notify: false });
    storyIntro.close({ welcome: false });
    hallCard.close();
    disconnect(); closePanel();
    S.you = null; S.charId = null; S.session = null;
    S.world = m.world && m.world.n > 0 ? m.world : null;
    setMusicScene('title');
    backToSelect();
    // 결산 카드가 선 자리에서는 오류 칸을 쓰지 않는다(세계 종료는 오류가 아니다). 카드를 못 세우면 옛 문장으로.
    showWorldRecap(recap, enterCharacter);
    if (document.getElementById('world-recap')) return;
    const old = Number(m.old || 0);
    const rules = worldRecapRules(recap);
    $('#err').textContent = old > 0
      ? `제 ${old} 세계가 끝났다. ${rules} 도움말 「세계가 끝나면」.`
      : `끝난 세계의 접속이다. ${rules} 다시 입장해 달라.`;
  });
  /**
   * 나 하나만 다시 보내는 것 — **거래가 끝난 직후**에 온다(`trade.ts`).
   *
   * 서버가 보내고 있는데 **클라에 읽는 곳이 0건이었다.** 이 레포 대표 결함이고,
   * 하필 물건이 오간 직후라 화면이 잠깐 옛 가방을 보여준다. 10Hz `state` 가
   * 곧 덮어써서 티가 덜 났을 뿐이지, **보낸 쪽은 "바로 갱신하라" 는 뜻으로 보냈다.**
   * 받아서 그 자리에서 반영한다 — 거래 창을 닫는 순간의 가방이 맞아야 한다.
   */
  on('you', (m) => { if (m.you) {
    S.you = applyFxPref(m.you); S.busy = null;
    recoverBoardWrites(); recoverBountyPost(); recoverTowerWrite(); recoverSlotSpin(send); recoverLotteryPurchase(); recoverLifeStoneUse(); recoverTownWrites();
    recoverExchangeWrite(send); // DESIGN 14.609 — 거래소 요청의 결과만 다시 확인한다(새 쓰기를 만들지 않는다)
    syncHud(); if (S.panel) renderPanel();
  } });
  on('goblinAck', goblinBuyAck);
  on('alchemyAck', alchemyActionAck);
  on('renameAck', renameAck);
  on('legendarySmith', (m) => {
    if (m?.smith) S.legendarySmith = m.smith;
    if (m?.result?.op === 'promote') toast('전설의 대장장이 승급 완료', 'gear');
    if (m?.result?.op === 'bless') toast('축복 장비 완성', 'shard');
    if (m?.smith && !m?.result) togglePanel('legendarySmith', true);
    if (S.panel) renderPanel(true);
  });
  /**
   * EXCHANGE-R1 — 스킬 포인트 교환 직후 잔량 즉시 반영. 서버가 부분 메시지
   * (skillFree/freeStats)만 보내는데 받는 핸들러가 없어 재접속 전엔 옛 값이었다.
   */
  on('skillFree', (m) => {
    if (!S.you) return;
    if (Number.isFinite(m.free)) S.you.skillFree = m.free;
    if (Number.isFinite(m.freeStats)) S.you.statFree = m.freeStats;
    syncHud(); syncSkills(); if (S.panel) renderPanel();
  });
  /** 자동 강화는 10Hz 월드 상태에 섞지 않는다. 단계가 끝날 때만 온다. */
  on('autoEnhance', (m) => {
    S.autoEnhance = m.job || null;
    if (S.panel === 'forge') renderPanel(true);
  });
  /**
   * **세계 시각이 늘었다** — 누군가 신전에 생명의 돌을 바쳤다 (CYCLE-R2 §4).
   *
   * 시계는 `init` 에 **한 번만** 온다(10Hz 방송에 실으면 그 대역폭이 인원수만큼
   * 곱해진다 — 14.20 에서 겪은 부류다). 그래서 이 밀어주기를 안 받으면
   * **접속해 있는 사람은 끝까지 옛 시각을 본다.** 바친 본인조차 안 바뀐다.
   *
   * `init` 과 **같은 규칙**으로 받는다 — `n === 0` 은 서버가 세계를 못 읽었을
   * 때의 임시값이라 화면에 안 띄운다. 여기서만 다르게 받으면 두 경로가 갈린다.
   */
  on('world', (m) => {
    S.world = m.world && m.world.n > 0 ? m.world : null;
    syncHud();
    /**
     * **세계 번호가 올라갔으면 알린다.** 판정과 저장은 `notify.js` 가 한다 —
     * 여기서 번호를 비교하면 `init` 경로와 두 벌이 된다.
     */
    if (S.world) worldChanged(S.world.n);
    if (S.panel) renderPanel();
  });
  /** 계정 영구 도감/기여 비석. 획득·봉헌 때만 오므로 10Hz state 에 섞지 않는다. */
  on('dex', (m) => {
    S.dex = m.dex || null;
    if (m.dex?.contributionRanks) contributionRanksAck();
    if (S.panel === 'dex' || S.panel === 'temple') renderPanel(true);
  });
  // Q276 — 탑 내용은 탑 앞 안내인 창(`tower`)과 [행사] › 시련의 탑 두 자리에 같은 그림으로 뜬다. 층 결과는 [행사] › 시련의 탑으로 연다
  const towerShown=()=>S.panel==='tower'||eventTabShown('tower');
  on('tower',m=>{
    const {run,changed}=receiveTower(m);
    if(changed&&run?.phase==='active'&&towerShown())closePanel();
    else if(changed&&['cleared','claimable','failed'].includes(run?.phase)){if(S.panel==='tower')renderPanel(true);else openEvents('tower');}
    else if(towerShown())renderPanel(true);
  });
  on('towerRank',m=>{S.towerRank=m;if(towerShown())renderPanel(true);});
  // UNI-Q193 — 명예의 전당(서버가 정한 이름·수치 그대로) · 새 세계 첫 입장 카드(지난 세계 기록, 한 번)
  on('hall', (m) => { S.hall = m; if (S.panel === 'hall') renderPanel(true); });
  // F5(14.511) — 섬 마을 동상(신전 앞 — 14.595 · 직전 세계 1~3위 외형·자리). 쿼터뷰가 다음 프레임부터 받침 위에 세운다(장식)
  on('statues', (m) => { S.statues = m; });
  on('hallCard', (m) => {
    if (m.entry && hallCard.show(m.entry)) log(`제 ${Number(m.entry.world) || 0} 세계의 명예의 전당이 새겨졌다 — 메뉴 › 세계 › 명예의 전당에서 다시 볼 수 있다.`, 'sys');
  });
  /** 길드는 D1 쓰기가 끝난 때만 온다. 10Hz 세계 상태에 큰 회원 목록을 섞지 않는다. */
  on('guild', (m) => {
    S.guild = m.guild || null;
    restoreGuildMoney();
    restoreGuildShop();
    if (S.panel === 'guild') renderPanel(true);
    syncHud();
  });
  /** UNI-Q186 공성전 — 선포·시작·끝·정산·신청 때만 온다(10Hz 상태에는 HUD 한 줄만). 받은 순간의 시각으로 남은 시간을 센다. Q276 — [행사] › 공성전 */
  on('siege', (m) => {
    S.siege = m.siege ? { ...m.siege, receivedAt: Date.now() / 1000 } : null;
    if (S.panel === 'events') renderPanel(true);
    syncMenuDot();
  });
  /** UNI-Q236 모의 공성전 — 신청/취소·판 시작/끝 때만 온다. Q276 — [행사] › 모의 공성전(전에는 게시판 여섯째 탭) */
  on('mockSiege', (m) => {
    S.mockSiege = m.mockSiege ? { ...m.mockSiege, receivedAt: Date.now() / 1000 } : null;
    if (S.panel === 'events') renderPanel(true);
    syncMenuDot();
  });
  // N5(2026-09-26) — 모집이 열리면(정기든 사람이 열었든) 접속 중인 사람 전원에게 온다. [행사]
  // 칸과는 별개로 어디서든 뜨는 참여 팝업/구석 알림 재료다. Q276 — 모집 중이면 [행사] 칸에 점이 켜진다.
  on('mockSiegeRecruit', (m) => { handleMockSiegeRecruit(m.recruit ?? null); syncMenuDot(); if (S.panel === 'events') renderPanel(true); });
  // 묶음 R-B(R130) — 사냥터에 있는 공성전 신청자: 「N초 뒤 전장으로 불려 간다」 카운트다운(입력은 막지 않는다)
  on('siegeRecall', (m) => showSiegeRecall(m));
  on('nativeGuilds', (m) => {
    S.nativeGuilds = Array.isArray(m.guilds) ? m.guilds : [];
    S.nativeMembership = m.myMembership && typeof m.myMembership === 'object' ? m.myMembership : null;
    if (S.panel === 'guild') renderPanel(true);
  });
  on('nativeGuildAck', (m) => {
    S.nativeGuilds = null;
    if (S.panel === 'guild') { send({ t:'nativeGuildGet' }); renderPanel(true); }
  });
  on('escapeFieldInfo',m=>{S.escapeFieldInfo=m;if(S.panel==='teleport')renderPanel(true);});
  on('escapeFieldAck',m=>{if(escapeEntryAck(m)){send({t:'escapeFieldInfo'});if(S.panel==='teleport')renderPanel(true);}});
  on('hellFieldInfo',m=>{S.hellFieldInfo=m;if(S.panel==='hellgate')renderPanel(true);});
  on('hellFieldAck',m=>{if(hellFieldAck(m)){send({t:'hellFieldInfo'});if(S.panel==='hellgate')renderPanel(true);}});
  on('guildEconomyAck', (m) => {
    if (guildMoneyAck(m) && S.panel === 'guild') renderPanel(true);
    // DESIGN 14.599 6단계 — 게임 서버 쪽 몸은 원천이 확정 앞에 밀던 길드 화면(금고·명예)을 받지 못한다: 확정되면 다시 읽는다
    if (m.ok && nativeRegionId()) send({ t: 'guildGet' });
  });
  on('guildShopAck', (m) => {
    if (guildShopAck(m) && (S.panel === 'guild' || S.panel === 'vault')) renderPanel(true);
  });
  on('guildItemAck', (m) => {
    if (guildShopAck(m) && (S.panel === 'guild' || S.panel === 'vault')) renderPanel(true);
  });
  on('guildBuildings', (m) => {
    if (applyGuildBuildings(m) && S.panel === 'guild') renderPanel(true);
  });
  on('installPrompt', (m) => configureInstallOffer(m.cfg));
  on('init', (m) => {
    S.nativeTrade=null; // A proposal belongs to the previous connection's live body.
    // R182 — 끊긴 몸 유지 시간(초). 사냥터 init 은 원천 값을 그대로 싣는다(field-connect `...init`).
    if (Number.isFinite(m.linkHoldSecs)) S.linkHoldSecs = m.linkHoldSecs;
    S.nativeEntrances = Array.isArray(m.nativeEntrances) ? m.nativeEntrances : [];
    // MAP0 R4 — 원천 init 이 사냥터 켜짐을 말한다(`nativeFields` — 없으면 정착지 출구가 있는가). 켜져 있으면 마을 둘레를 사냥터 땅으로,
    // 꺼져 있으면(킬스위치 비상 판) 1.0 그대로 그린다. 사냥터 init(지형을 싣는다)은 이 값을 말하지 않는다 — 그대로 둔다
    if (!m.fieldGeometry) setSourceSurroundingsEnabled(typeof m.nativeFields === 'boolean' ? m.nativeFields : S.nativeEntrances.length > 0);
    // 14.523(F12) — 그중 지금 사냥터 서버가 쥔 사냥터(원천이 1.0 으로 대신 돌리는 땅은 1.0 그대로 그린다). 옛 원천은 말하지 않는다(null — 전부)
    if (!m.fieldGeometry) setSourceNativeFields(Array.isArray(m.nativeFieldIds) ? m.nativeFieldIds : null);
    configureInstallOffer(m.installPrompt);
    S.you = applyFxPref(m.you);
    void refreshWorldNotify();
    // INVITE-R2 — 초대 이벤트 새 소식은 서버 켬끔을 따라 실린다(광고 공지 방식)
    S.inviteOn = !!m.inviteOn;
    S.guild = null;
    S.guildMoneyConfirmation = null;
    S.guildShopConfirmation = null;
    if (S.guildShopPending?.charId !== S.charId) S.guildShopPending = null;
    if (S.guildMoneyPending?.charId !== S.charId) S.guildMoneyPending = null;
    /**
     * ⚠ **처음 본 번호는 안 알린다** — `worldChanged` 가 그것을 판정한다.
     * 여기서 부르는 이유는 **지금 세계 번호를 기억해 두기 위해서**다.
     * 안 부르면 다음 세계가 열려도 "처음 본 번호" 가 되어 영영 안 울린다.
     */
    if (m.world && m.world.n > 0) worldChanged(m.world.n);
    // n === 0 은 서버가 세계를 못 읽었을 때의 임시값이다. 그건 화면에 안 띄운다.
    S.world = m.world && m.world.n > 0 ? m.world : null;
    S.deal = m.deal || null;
    recoverTownWrites(); recoverExchangeWrite(send);
    /**
     * 안내창은 **첫 입장에서만**. `init` 은 재연결·세션 인계에서도 온다 —
     * 여기서 무조건 부르면 연결이 불안정한 사람에게는 화면 전체 덮개가
     * 접속할 때마다 돌아온다. 실제로 그렇게 클릭이 통째로 막혔다.
     */
    const cid = S.charId || '';
    /**
     * R126(레드팀 C5) — 스토리 카드가 **실제로 뜬 입장**(이 기기에서 이 캐릭터가 처음)이면 30초 동안 조용한 창을 연다:
     * 공지 띠·알림 토스트·기록 미리보기·설치 카드·지난 세계 카드·모의 공성전 창은 그 뒤로(문장은 기록에 남는다).
     * 바로 아래의 최근 공지 재생도 이 창 안에서 기록으로만 간다.
     */
    const firstEntry = !entered.has(cid); // R200 — 접속 안내 두 줄도 이 캐릭터의 첫 입장에서만
    if (!entered.has(cid)) { entered.add(cid); introWhenVisible(cid); }
    /**
     * R200(DESIGN 14.404) — `init` 은 첫 입장뿐 아니라 재접속·사냥터→마을 복귀마다 온다(복귀는 원천 연결을 새로 연다). 원천은 그때마다
     * 최근 공지 6건을 싣는데, 전에는 받을 때마다 전부 다시 띄우고 접속 안내 두 줄도 다시 찍어서 방금 죽고 잃은 물건 목록이 그 소음에
     * 밀려 올라갔다. 이 화면이 이미 보인 공지(목록으로든 실시간 방송으로든)는 다시 띄우지 않고, 안내 두 줄은 이 캐릭터의 첫 입장에서만.
     */
    for (const a of m.announces || []) {
      const key = `${a.at}|${a.text}`;
      if (annShown.has(key)) continue;
      annShown.add(key);
      if (annShown.size > 200) annShown.delete(annShown.values().next().value);
      const live = annLive.indexOf(a.text);
      if (live >= 0) { annLive.splice(live, 1); continue; }
      pushAnn(a.text);
    }
    if (firstEntry) {
      log('접속했다. 바닥을 누르면 이동하고, 몬스터를 누르면 공격한다.', 'sys');
      /**
       * ⚠ **모바일에는 `H` 키가 없다.** 좁은 화면에서는 `#b-help`(`? H`)를 숨기고
       * `[? 조작]` 탭이 대신하는데(오늘 사용자가 그걸 못 찾아 신고했다), 이 안내는
       * **아직도 없는 키를 누르라고** 하고 있었다. 두 화면 모두에 있는 것을 가리킨다.
       */
      // Q276 — 도움말은 [메뉴] › 시스템 › 도움말(늘 보이는 다섯 칸의 [메뉴])
      log('자동 공격은 하단 [자동] 버튼에서 설정한다. 자세한 조작은 [메뉴] › 도움말에서 볼 수 있다.', 'sys');
    }
    syncHud();
  });
  /**
   * 오늘의 특가가 바뀌었다 (하루 경계, KST 자정).
   *
   * **값을 클라가 다시 계산하지 않는다.** 서버가 물건 표와 날짜를 들고 있고
   * 실제로 그 값으로 판다 — 화면이 따로 셈하면 언젠가 **파는 값과 적힌 값이
   * 갈라진다.** 받은 것을 그대로 보여준다.
   */
  on('deal', (m) => { S.deal = m.deal || null; if (S.panel) renderPanel(); });
  on('chat', (m) => onChat(m, log));
  on('log', (m) => {
    log(m.msg, m.bad ? 'bad' : m.sys ? 'sys' : '');
    cueLog(m.msg, !!m.bad, m.cross, m.req);   // C12b(14.480) — 넘기 거절 줄의 까닭 코드(`cross`)를 이동 표시가 한국어로 잠깐 말한다(코드 없는 줄은 안 빌린다 · 요청 번호가 붙은 줄은 그 요청의 답이 걷는다)
    if (m.msg.startsWith('⚠')) SFX.warn();
  });
  // Q281(14.568) — 이동 요청(텔레포터)의 답. 거절이면 까닭과 함께 그 요청의 덮개를 곧바로 걷는다(다른 요청의 답은 무시 — 번호로 짝을 맞춘다)
  on('travelAck', (m) => { cueTravelAck(m); });
  on('toast', (m) => {
    if (!toast(m.text, m.kind, { earned: typeof m.earned === 'boolean' ? m.earned : undefined })) return;
    if (m.kind === 'shard') SFX.shard();
    else if (m.kind === 'silver') SFX.coin();
    else if (m.kind === 'gear') SFX.forge();
    // UNI-Q194 원주민 라이벌 알림 — 얻은 것이 아니라 소식이라 줍는 소리를 내지 않는다
    else if (m.kind === 'rival') SFX.ui();
    // F23(DESIGN 14.530) — 급습 몬스터가 나를 골랐다: 짧은 경고음(낮은 두 음 — 보스 기술·⚠ 문장과 같은 소리)
    else if (m.kind === 'raid') SFX.warn();
    else SFX.loot();
  });
  on('announce', (m) => {
    // R200 — 실시간으로 본 공지는 다음 `init` 의 최근 목록에서 다시 띄우지 않는다
    annLive.push(m.text); if (annLive.length > 40) annLive.shift();
    pushAnn(m.text, !!m.epic);
  });
  // INVITE-R1 — 내 초대 링크 회신. 도움말 패널이 그린다
  on('inviteLink', (m) => {
    S.inviteLink = { code: m.code, enabled: !!m.enabled };
    if (S.panel === 'help') renderPanel(true);
  });
  on('levelup', (m) => {
    float(`LEVEL ${m.level}`, '#ffe9a8', 2.4, 30);
    flash('#d4a83c');
    // UNI-Q156 — 금빛 기둥 고리와 솟는 불티(타격감 연출이 켜졌을 때)
    if (S.you?.hitFeel) hitFeel.celebrate(S.you.x, S.you.y, performance.now());
    // 첫 입장에는 포인트 설명을 여러 번 띄우지 않고, 내가 얻은 첫 성장의 결과를 한 줄로 보여 준다.
    const growth = quietStart() ? [m.gained > 0 && `스탯 +${m.gained}`, m.skillFree > 0 && `스킬 포인트 ${m.skillFree} 남음`].filter(Boolean) : [];
    toast(`레벨 ${m.level} 달성${growth.length ? ` · ${growth.join(' · ')}` : ''}`, 'level', { earned: true });
    /**
     * **포인트를 받았다는 사실을 그 자리에서 말한다.**
     *
     * 전에는 레벨만 알렸고 남은 포인트는 다음 상태 틱에 조용히 늘었다.
     * 그래서 "레벨업을 해도 스탯을 안 주는 것 같다" 는 보고가 나왔다 —
     * **주고 있었다.** 준 것을 말하지 않은 것이 결함이었다.
     * 어디서 쓰는지까지 적어야 한 번에 끝난다("가방에서 찍는다").
     *
     * 받은 개수는 클라에 베껴 적지 않고 서버의 `gained`를 쓴다. Lv50 뒤에는
     * 3점→4점으로 바뀌므로 남은 총량만 말하면 이번 성장의 차이를 알 수 없다.
     */
    if (m.free > 0) {
      toast(`스탯 포인트 +${m.gained} · 남은 ${m.free}`, 'level');
      log(`★ 스탯 포인트 ${m.gained}개를 받았다. 지금 ${m.free}개 — 가방(I) 에서 올린다.`, 'sys');
    }
    if (m.skillFree > 0) {
      toast(`스킬 포인트 ${m.skillFree} · 스킬 탭에서 강화한다`, 'level');
      log(`★ 스킬 포인트가 남아 있다 (${m.skillFree}개). [스킬] 칸에서 강화한다.`, 'sys');
    }
    SFX.levelup();
    // 하단 경험치 줄이 흰색으로 번쩍이고 0 으로 되감긴다 — 레벨업이 화면에서 보인다
    const xl = $('#xpline'); if (xl) { xl.classList.add('up'); setTimeout(() => xl.classList.remove('up'), 700); }
  });
  /**
   * 묶음 CB2b(N10) — 타격 기록을 낸 쪽의 무기 결. 나·사람은 직업, 경비병·보디가드는 서버가 보낸 역할(`k`), 나머지(몬스터·짐승 동료)는 발톱·몽둥이.
   * F16 — 전에는 경비병 줄이면 늘 칼이라 경비궁수·호위궁수의 화살도 칼 소리로 꽂혔다(그림이 늘 칼이던 것과 같은 결함).
   */
  const klassOf = (f, st) => {
    if (st.you && f.sid === st.you.id) return st.you.klass;
    const p = st.players.find((q) => q.id === f.sid);
    if (p) return p.k;
    const g = (st.guards || []).find((q) => q.id === f.sid);
    return g ? (g.k === 'ranged' ? 'ranged' : 'melee') : 'mon';
  };
  /**
   * 타격음 — 서버가 주는 fx 로 판정한다.
   * 소리 하나 때문에 프로토콜을 늘리면 그 대역폭이 동시 100명분으로 곱해진다.
   * f.p 는 '몬스터가 나를 때렸다' 이고, 그건 hurt 로 따로 낸다(피격은 체력 변화로 잡는다).
   */
  on('fx', (f) => {
    const y = S.you; if (!y) return;
    // 묶음 Z2 — 도착한 순간은 휘두름이 **시작**하는 순간이다: 휘두름·시위·몬스터 기합만 낸다(서버 시차 `dl` 만큼 미뤄)
    soundDirector()?.fx(f, S);
  });
  /**
   * 묶음 Z2(평론 #2) — 타격음은 **그림이 닿는 순간**에 난다(iso-scene `land` → impact-bus). 전에는 위 `fx` 도착 순간에 냈다 —
   * 근접은 칼이 닿기 235ms 전, 원거리는 화살이 닿기 최대 0.5초 전, 연타·튀김은 서버 시차 `dl` 를 무시하고 한꺼번에 났다.
   * 피격(나를 친 것)·처치·재질층·헛손질·쓰러짐 소리도 같은 알림에서 난다(sound-director.js).
   */
  setAudioLead(audioLeadMs);   // 묶음 CL1(N15) — 그림이 닿는 순간을 미리 아는 타격의 소리는 기기 출력 지연만큼 먼저(iso-scene ④ shots)
  onImpact((ev) => soundDirector()?.impact(ev, S, (f, d, opts) => {
    /**
     * 바탕 타격음(무기 결 합성 `impact` — 묶음을 받기 전·실패 때는 녹음 hit/crit) — **거리에 따라 잦아든다** (사용자: "환경음은 거리에 따라 감쇠시켜"). `d` 는 과녁까지의 거리,
     * `opts` 는 화면 좌우 위치(`pan`)와 내 소리 여부(`personal` — 남의 소리와 동시 발음 몫을 따로 센다). 멀어 무시할 만큼 작으면
     * 재생하지 않는다(`envAt`). 나를 친 것은 여기 오지 않고 `SFX.hurt` 가 낸다(sound-director.js — 거리 규칙 밖).
     */
    // 함수를 **부르는 모양**으로 넘긴다. `SFX.crit` 처럼 참조로 넘기면
    // `check-client` 의 "죽은 효과음" 검사 항목이 호출을 못 보고 **정의만 있고 안 부른다**
    // 고 잡는다. 검사기를 무디게 만드느니 호출을 눈에 보이게 두는 편이 낫다.
    // 피해량 40을 치명타로 추측하던 옛 임시 규칙은 버린다. 약한 치명타도 치명타고,
    // 강한 평타도 평타다 — 서버가 실제 판정한 `c`만 믿는다.
    // 묶음 CB2b(N10) — 바탕은 친 쪽의 무기 결(칼·화살·단검·발톱)로 낸다. 내 한 방은 반드시 난다(`personal`)
    return envAt(() => (f.c ? SFX.crit(klassOf(f, S), !!opts?.personal) : SFX.hit(klassOf(f, S), !!opts?.personal)), d, opts);
  }));
  on('skill', (m) => { float(`「${m.name}」 습득`, '#8cbd87', 2.2, 46); SFX.ascend(); });
  on('cool', () => syncSkills());
  on('died', (m) => {
    storyIntro.close({ welcome: false });
    endQuietStart(); // 죽었으면 조용히 있을 때가 아니다 — 잃은 것·복구 안내가 떠야 한다
    hideReturnOptions(); // 시체 위에 귀환 팝업이 남지 않게
    // 시체 자리를 기억한다 — 미니맵이 여기로 안내한다 (DESIGN 14.32).
    // `t:'died'` 에는 좌표가 없어서 직전 상태 틱의 좌표를 쓴다. 한 틱 오차인데
    // 드롭이 2.0~2.4 타일로 흩어지므로 회수에는 무해하다.
    // R97(DESIGN 14.366) — which hunting ground the body fell in. Native fields reuse world coordinates
    // (a field's annex covers forest ground), so the same (x,y) from another field is a different place.
    if (S.you) S.corpse = { x: S.you.x, y: S.you.y, field: nativeFieldGeometry()?.fieldId ?? null,
      // 묶음 Y(14.429, G11) — 사냥터가 준 남는 시간(`dropSecs`, 갱도 층은 더 길다)을 따른다
      until: performance.now() + (Number(m.dropSecs) > 0 ? Number(m.dropSecs) : DEATH_DROP_TTL) * 1000 };
    $('#dead').classList.add('on');
    const lost = deathLostLabels(m); // R41 — 사냥터(러스트)의 내부 키를 기존 이름표로
    /**
     * **잃은 경험치를 아무도 말해주지 않았다.**
     *
     * 서버는 `lostExp` 를 계산해서 깎고 화면까지 보내고 있었는데(`combat.ts:485`)
     * 클라이언트에 그 값을 읽는 곳이 **0건**이었다. 이 레포 대표 결함("보내놓고
     * 안 읽는 것")이 하필 하드코어의 핵심 대가에 걸려 있었다 — 죽으면 무엇을
     * 잃는지가 이 게임의 규칙 자체인데, 그중 절반이 조용히 사라지고 있었다.
     */
    const exp = m.lostExp > 0 ? `잃은 경험치 <b>${numLabel(m.lostExp)}</b>` : '';
    // R213(C2-3) — 무엇에게·어디서 쓰러졌고 떨군 것이 몇 분 남는지. 사냥터는 `by`·`dropSecs`, 섬은 `by`, PK 는 `slainBy`.
    const by = String(m.by || m.slainBy?.name || '').trim();
    const place = S.you ? placeInfo(S.you).place : '';
    const mins = Math.max(1, Math.round((Number(m.dropSecs) > 0 ? Number(m.dropSecs) : DEATH_DROP_TTL) / 60));
    $('#deadmsg').innerHTML = (by ? `<b>${esc(by)}</b>에게 쓰러졌다${place ? ` · ${esc(place)}` : ''}<br>` : '') + (lost.length
      ? `바닥에 떨어뜨렸다 — <b>${lost.slice(0, 5).map(esc).join(', ')}</b>`
        + (lost.length > 5 ? ` 외 ${lost.length - 5}건` : '')
        + `<br><span class="qt">떨어뜨린 것은 쓰러진 자리에 ${mins}분 남는다.<br>서둘러 돌아가면 다시 주울 수 있다.</span>`
      // R-SAFE0(14.346) — 초반 사망 보호로 안 잃은 것을 「지닌 것이 없다」로 말하면 틀린 말이다(물약·무기를 들고 있었다).
      : m.safeLevel > 0 ? `Lv${Number(m.safeLevel)} 전이라 잃은 것이 없다 — Lv${Number(m.safeLevel)}부터는 죽으면 물건과 경험치를 잃는다.`
      : '떨어뜨린 물건은 없다.')
      + (exp ? `<br>${exp}` : '')
      + '<br><span class="qt">화면을 누르면 닫힌다</span>';
    const nextChoice = document.createElement('div');
    nextChoice.className = 'ux-actions';
    const afterDeath = (label, action) => {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = label;
      button.onclick = (ev) => { ev.stopPropagation(); clearTimeout(deadTimer); $('#dead').classList.remove('on'); action(); };
      nextChoice.appendChild(button);
    };
    if (lost.length) afterDeath('떨어뜨린 곳 보기', () => openWorldMapAt(S.corpse?.field));
    afterDeath('가방에서 재정비', () => { S.invView = 'gear'; togglePanel('inv', true); });
    $('#deadmsg').appendChild(nextChoice);
    /**
     * 화면은 5초 뒤 사라지지만 **잃은 목록은 그때 같이 사라지면 안 된다.**
     * 5건 + "외 N건" 을 5초에 다 읽을 수 없고, 돌아가서 주울지 판단하려면
     * 다시 봐야 한다. 전투 로그에 남겨 되읽을 수 있게 한다.
     */
    /**
     * ADS-PREP-R1 — 부활 광고 「자리」. `revival` 플래그가 꺼져 있으면(지금 상태)
     * 이 버튼은 존재하지 않는다 — 절대규칙 5(광고로 하드코어 우회 금지)와 충돌해
     * 규칙 개정 전엔 서버 플래그가 항상 거짓이다. 자리만 미리 파둔다는 지시(3d).
     */
    // AD-RECOVER-R1 — 서버가 켠 신호(canRecover)로만 나타난다. 플래그·PK 판정은 서버 것이다.
    // AD-REWARDS-NATIVE — Rust says canRecover as the source does (DESIGN 14.599 3-6c: the gate claims the owner's unclaimed
    // field drops and returns them). The `nativeActionAllowed` check keeps the button off a socket that would drop
    // `adRecover` — no ad watched for nothing.
    if (m.canRecover && nativeActionAllowed('adRecover')) {
      const rec = document.createElement('button');
      rec.className = 'wide';
      rec.textContent = '광고 보고 잃은 것 창고로 복구 (하루 1회)';
      rec.onclick = async (ev) => {
        ev.stopPropagation();
        if (!nativeActionAllowed('adRecover')) return;
        rec.disabled = true;
        const r = await showRewarded('recover');
        if (r.viewed) send({ t: 'adRecover' });
        else { rec.disabled = false; log('광고가 나오지 않았다 — ' + r.status, 'bad'); }
      };
      $('#deadmsg').appendChild(document.createElement('br'));
      $('#deadmsg').appendChild(rec);
    }
    // AD-REWARDS-NATIVE — same guard for `adRevive` (currently always off via
    // adsStatus().revival, kept for when Google SSV lands).
    if (adsStatus().revival && nativeActionAllowed('adRevive')) {
      const btn = document.createElement('button');
      btn.className = 'gold wide';
      btn.textContent = '광고 보고 그 자리에서 일어난다';
      btn.onclick = async (ev) => {
        ev.stopPropagation();
        if (!nativeActionAllowed('adRevive')) return;
        btn.disabled = true;
        const r = await showRewarded('revival');
        if (r.viewed) send({ t: 'adRevive' });
        else { btn.disabled = false; log('광고가 나오지 않았다 — ' + r.status, 'bad'); }
      };
      $('#deadmsg').appendChild(document.createElement('br'));
      $('#deadmsg').appendChild(btn);
    }
    /**
     * BOUNTY — **PK 로 죽었으면 그 자를 바로 수배**(복수 진입점). `died.slainBy` 는
     * 사람 막타만 `{name}`, 몬스터·경비병 처형은 null 이다(65 서버 계약). 평문 부고를
     * 파싱하지 않고 이 구조 필드로 연다. 사망 화면을 닫고 게시판 현상금 탭을 이름 채워 연다.
     */
    if (m.slainBy && m.slainBy.name) {
      const bb = document.createElement('button');
      bb.className = 'wide';
      bb.textContent = `${m.slainBy.name}에게 현상금 걸기`;
      bb.onclick = (ev) => {
        ev.stopPropagation();
        clearTimeout(deadTimer);
        $('#dead').classList.remove('on');
        window.act?.bountyOpen?.(m.slainBy.name);
      };
      $('#deadmsg').appendChild(document.createElement('br'));
      $('#deadmsg').appendChild(bb);
    }
    if (lost.length) log(`잃은 것: ${lost.join(', ')}`, 'bad');
    if (m.lostExp > 0) log(`잃은 경험치 ${numLabel(m.lostExp)}`, 'bad');
    SFX.died();
    // 연속으로 죽으면 앞선 타이머가 **다음 사망 화면**을 일찍 닫아버린다
    clearTimeout(deadTimer);
    deadTimer = setTimeout(() => $('#dead').classList.remove('on'), 5200);
  });
  on('nativeTrade', (m) => { S.nativeTrade=m; if(S.panel==='resident')renderPanel(true); });
  // R229 — 원주민 창 「나와의 관계」·인사 답. 이 세계 교감 켬끔은 도움말의 대화 문단도 가른다
  on('residentRel', (m) => { S.residentRel = { ...m, receivedAt: Date.now() }; S.socialOn = !!m.socialOn; if (S.panel === 'resident' || S.panel === 'help') renderPanel(true); });
  on('nativeMarket', (m) => { S.nativeMarket = m; if (S.panel === 'nativeMarket') renderPanel(true); });
  on('nativeMarketChanged', () => { if (S.panel === 'nativeMarket') send({ t: 'nativeMarketGet' }); });
  on('vault', (m) => {
    S.vault = m.vault;
    // 경주도 창고 은화를 예산으로 보여준다. 차감 뒤 옛 합계를 남기지 않는다.
    if (S.panel === 'vault' || S.panel === 'race') renderPanel(true);
  });
  on('race', (m) => { S.race = m.race; if (S.panel === 'race') renderPanel(); });
  /**
   * UNI-Q161 — 초당 피해 표. **받은 순서 그대로** 담는다(화면에서 다시 정렬하지 않는다).
   */
  on('dpsBoard', (m) => { S.dpsBoard = m; if (S.panel === 'dps') renderPanel(true); });
  /**
   * 측정이 끝났다. 패널이 열려 있으면 그 갈래를 **다시 받는다** — 방금 기록이
   * 표에 안 올라가 있으면 사람은 *"안 저장됐다"* 로 읽는다.
   */
  on('dpsDone', (m) => {
    S.dpsLast = m;
    float(`${floatNum(m.dps || 0)} / 초`, '#ffcf9a', 2.4, 52);   // C6(14.476) — 떠오르는 숫자는 한 포맷터(정확한 값은 피해 측정 표)
    if (S.panel === 'dps') send({ t: 'dpsBoard', scope: S.dpsScope });
  });
  on('lottery', (m) => {
    S.lottery = m;
    S.lotteryBusy = !!S.lotteryPurchase;
    if (S.panel === 'lottery') renderPanel(true);
  });
  on('lotteryBuyAck', lotteryBuyAck);
  on('lifeStoneUseAck', (m) => { if (lifeStoneUseAck(m, () => { if (S.panel === 'inv') renderPanel(true); })) syncHud(); });
  // R124(레드팀 C3) — 남의 당첨은 소리 없이 작은 결과 카드로만(당첨 연출 축소)
  on('lotteryDraw', (m) => {
    showLotteryFanfare(m.draw, !!m.replay);
  });
  on('lotteryChanged', () => {
    if (S.panel === 'lottery') send({ t: 'lotteryGet' });
  });
  // 블랙잭(UNI-Q41) — 서버가 단계·손패가 바뀔 때만 민다. 잭팟·고배당은 복권 팡파레 자리를 빌린다
  on('bj', (m) => { S.blackjack = m.table; if (S.panel === 'blackjack') renderPanel(true); });
  on('bjFanfare', (m) => { showBlackjackFanfare(m.win); });
  // UNI-Q184 슬롯머신 — 여는 순간의 기금·설정값, 한 판 결과(저장 확정 뒤), 잭팟(창고 지급 뒤)
  on('slot', (m) => { S.slot = m; if (S.panel === 'slot' || gambleHubOpen()) renderPanel(true); });
  // 내 판의 당첨은 동전 소리 하나(큰 배당도 같다). 잭팟이 실제로 창고에 들어온 순간(slotJackpot)만 짧은 가락
  on('slotAck', (m) => onSlotAck(m, () => { if (S.panel === 'slot') renderPanel(true); }, () => SFX.coin(), send));
  on('slotJackpot', () => SFX.lottery());
  on('board', (m) => {
    S.board = { posts: m.posts || [], canModerate: !!m.canModerate, error: m.error || '' };
    // A list may arrive before the write ACK; only boardAck settles a submitted write.
    if (S.panel === 'board') renderPanel(true);
  });
  // Q276 — 매물 목록(전에는 게시판 부동산 탭)도 메뉴 › 마을 › 부동산 창 안에 있다
  on('realty', (m) => { S.realty = m; if (S.panel === 'realty') renderPanel(true); });
  on('realtyChanged', () => {
    if (S.panel === 'realty') { send({ t: 'realtyHome' }); send({ t: 'realtyList' }); }
  });
  // UNI-Q28 — 「부동산」 메뉴 자료. UNI-Q21 — 초대는 점으로 알린다(팝업 금지 — 절대규칙 4). Q276 — [메뉴] 칸과 메뉴 화면의 「부동산」 칸
  on('realtyHome', (m) => { S.realtyHome = m; if (S.panel === 'realty') renderPanel(true); });
  on('realtyInviteAsk', () => {
    S.realtyInviteDot = S.panel !== 'realty';
    syncMenuDot();
    if (S.panel === 'menu') renderPanel(true);
    if (S.panel === 'realty') send({ t: 'realtyHome' });
  });
  // UNI-Q22 — 귀환 후보가 둘 이상일 때만 온다. 하나면 서버가 바로 시전한다.
  on('returnOptions', (m) => showReturnOptions(m.candidates || []));
  on('fieldReturn', (m) => {
    hideReturnOptions();
    clearSiegeRecall();
    travelOnFieldReturn(m);   // F28 — 떠남이 없었으면(사망·공성 소집·콘텐츠) 여기서 이동 막을 세운다
    if (m.message) log(m.message, 'sys');
  });
  on('nativeTransition', (m) => {
    // R193 — 같은 넘기기 안에서 조용히 다시 잇는 시도(넘기기 표시가 꺼지지 않은 채 다시 켜짐)는 20초 정체 시계를 새로 시작하지 않는다
    const sameCrossing = fieldHandoff && !!m.active;
    fieldHandoff = !!m.active;
    if (m.active) {
      goalsRefreshRequested = ''; releaseGoalClaim();
      if (S.petRevivePending) { clearTimeout(S.petRevivePending.timer); S.petRevivePending = null; }
    }
    /**
     * R193(DESIGN 14.404) — 사냥터에서 마을로 돌아오는 것도 넘기기다(`returning`). 걸어서·귀환·사망마다 뜨던 「연결이 끊겼다」 대신
     * 들어가는 방향과 같은 작은 표시를 쓰고, 문구만 그 이동대로 말한다.
     */
    /**
     * C9(DESIGN 14.476) — 표시는 「이동 중 — 목적지」(닿는 순간 이미 떴으면 그 표시를 이어 간다). 목적지는 인계가 말하는 사냥터(`fieldId`·`destinationField`),
     * 걸어서 마을로 들어가면 「마을」. 닿아서 시작한 이동이 아닌 것(사망·귀환 주문서·공성 소집)은 그 이동대로 말한다.
     */
    const shiftDest = !m.returning ? fieldName(m.fieldId) : m.destinationField ? fieldName(m.destinationField) : '마을';
    const shiftText = !m.returning || m.destinationField ? null
      : m.reason === 'death' ? '마을에서 다시 일어나는 중…'
        : m.reason === 'scroll' ? '이동 중 — 마을(귀환)'
          : m.reason === 'siege' ? '이동 중 — 공성전 전장' : null;
    if (m.active) handoffDoing = entry.on ? '사냥터에 들어가는 중이라' : m.returning ? '마을로 가는 중이라' : '사냥터를 잇는 중이라';
    const el = $('#page-loading');
    if (!el) return;
    const label = el.querySelector('span');
    if (!label) return;
    /**
     * R187 — 첫 입장 중이면 가운데 판이 단계만 바꾼다(끊김 없는 지상 이동의 작은 표시·20초 덮개를 쓰지 않는다).
     * R194(DESIGN 14.404) — 판은 넘기기가 **끝날 때** 닫는다. 전에는 원천의 첫 상태에서 닫혀, 이어지는 사냥터 넘기기(2~6초) 동안
     * 몬스터 없는 들판에서 클릭·물약이 소리 없이 버려졌다. 넘기기가 끝났는데 원천에 그대로 붙어 있으면(사냥터가 거절·기능 꺼짐) 그때 닫는다.
     */
    if (entry.on) {
      if (m.active) entryShow(m.returning ? '세계에 들어가는 중…' : '사냥터로 들어가는 중…', m.returning ? 0.62 : 0.8);
      else if (S.connected) entryReady();
      return;
    }
    /**
     * SEAMLESS-R1 — 게임이 이미 한 번 떠 있는 채로(=el 이 이미 'ready') 경계를 건널 때는 전면 덮개를 다시 씌우지 않는다.
     * 묶음 X(T3, DESIGN 14.437) — 갱도 입구·층 계단·레어 문도 같다. 전에는 이 자리만 전면 덮개(「사냥터로 이동하는 중…」)를 써서
     * 층을 오갈 때마다 화면이 검게 가려졌다(로컬 실측 1.7~7.5초). 마지막 화면을 그대로 두고, 2초를 넘기면 작은 표시만 켠다.
     * 처음 접속하는 순간(el 이 아직 'ready' 아님)만 전면 판을 쓴다.
     */
    const seamless = el.classList.contains('ready') && !el.nativeTransitionActive;
    if (m.active) {
      // C9 — 다시 잇는 시도(`retry` — 넘는 칸에 닿아 시작한 이동이 아니면)는 「다시 연결하는 중…」. 같은 넘기기 안이면 이동 표시를 그대로 잇는다(늘 보이게 다시 그린다)
      const reconnect = !!m.retry && cuePhase() !== 'touch' && cuePhase() !== 'moving';
      if (seamless) { void sameCrossing; showFieldShift(reconnect ? '다시 연결하는 중…' : shiftText, shiftDest, reconnect ? 'reconnect' : 'field'); return; }
      if (el.nativeTransitionActive) return;
      clearTimeout(el.nativeTransitionTimer);
      el.nativeTransitionActive = true;
      label.textContent = shiftText || `이동 중 — ${shiftDest}`;
      el.classList.remove('ready');
      // A stalled handoff must never leave the entire game covered indefinitely.
      // C9(14.476) — 덮개를 걷고 이동 표시(「연결 확인 중 — 잠시만」 → 「눌러서 다시 잇기」)로 넘긴다. 「연결 지연」 창은 띄우지 않는다(관문 3)
      el.nativeTransitionTimer = setTimeout(() => {
        el.classList.add('ready');
        label.textContent = '게임을 불러오는 중…';
        showFieldShift(shiftText, shiftDest);
      }, 8000);
    } else {
      cueEnded();   // C9 — 다른 땅에 섰으면 지우고, 넘지 못했으면 까닭(붉은 기록)을 잠깐 보인 뒤 지운다
      clearTimeout(el.nativeTransitionTimer);
      el.nativeTransitionActive = false;
      el.classList.add('ready');
      label.textContent = '게임을 불러오는 중…';
      if (S.connected) $('#link')?.classList.remove('on');
    }
  });
  on('boardAck', (m) => {
    const kind = m.action === 'tradePost' || m.action === 'tradeRemove' ? 'trade' : 'board';
    const outcome = resolvePendingWrite(kind, m, send);
    if (outcome === 'ignore' || outcome === 'pending' || outcome === 'retrying') return;
    if (outcome === 'expired' || outcome === 'conflict') log('게시판 요청을 확정하지 못했다. 초안을 확인하고 다시 시도해 달라.', 'bad');
    else if (outcome === 'rejected' && m.error) log(m.error, 'bad');
    // R232 — 사고팔기 글의 결과도 같은 확인으로 온다(action tradePost·tradeRemove). 그 갈래는 사고팔기 상태만 푼다
    if (m.action === 'tradePost' || m.action === 'tradeRemove') {
      S.tradeBusy = false;
      if (m.ok && m.action === 'tradePost') S.tradeDraft = '';
      if (S.panel === 'board') renderPanel(true);
      return;
    }
    S.boardBusy = false;
    if (m.ok && m.action === 'post') S.boardDraft = '';
    // 댓글 성공이면 **방금 보낸 글의 초안만** 지운다(실패면 남겨 재시도). boardChanged 가 목록을 다시 받아온다.
    if (m.ok && m.action === 'comment' && S.commentPending) { delete S.commentDraft[S.commentPending]; }
    if (m.action === 'comment') S.commentPending = null;
    if (S.panel === 'board') renderPanel(true);
  });
  // 다른 사람이 남기거나 내린 글은 패널을 보고 있는 사람에게만 다시 요청한다.
  on('boardChanged', () => { if (S.panel === 'board') send({ t: 'boardList' }); });
  // R232 — 게시판 「사고팔기」 탭. 목록·결과·다른 사람이 올리거나 내린 글(보고 있는 사람만 다시 받는다)
  on('tradeBoard', (m) => {
    S.tradeBoard = { posts: m.posts || [], canModerate: !!m.canModerate, limits: m.limits || null, error: m.error || '' };
    // Refreshing the list must not reopen a pending post/remove button.
    if (S.panel === 'board' && S.boardTab === 'trade') renderPanel(true);
  });
  on('tradeBoardChanged', () => { if (S.panel === 'board' && S.boardTab === 'trade' && S.tradeView === 'posts') send({ t: 'boardTradeList' }); });
  // DESIGN 14.609 — 거래소(사고팔기 탭의 첫 칸): 목록 · 세 쓰기의 결과 · 다른 사람이 올리거나 내리거나 산 줄(보고 있는 사람만 다시 받는다)
  on('exchange', (m) => {
    onExchange(m);
    if (S.panel === 'board' && S.boardTab === 'trade' && S.tradeView !== 'posts') renderPanel(true);
  });
  on('exchangeAck', (m) => exchangeAck(m, () => SFX.coin()));
  // 쓰기마다 열린 탭 전부가 목록을 다시 읽으면 D1 읽기가 쓰기 수 × 보는 사람 수로 는다 — 한 사람의 다시 읽기는 3초에 한 번으로 묶는다
  //   (그 사이 온 소식은 끝에 한 번 더 읽어 놓치지 않는다)
  let exchangeReadAt = 0, exchangeReadTimer = 0;
  const exchangeOpen = () => S.panel === 'board' && S.boardTab === 'trade' && S.tradeView !== 'posts';
  on('exchangeChanged', () => {
    if (!exchangeOpen() || exchangeReadTimer) return;
    const wait = exchangeReadAt + 3000 - Date.now();
    const read = () => { exchangeReadTimer = 0; exchangeReadAt = Date.now(); if (exchangeOpen() && !S.exchangeBusy) send({ t: 'exchangeList' }); };
    if (wait > 0) exchangeReadTimer = setTimeout(read, wait); else read();
  });
  // BOUNTY-R2 P2 — 현상금 포스터/공지 목록. 서버 회신을 칸 상태에 담는다(Q276 — [행사] › 현상금·공지, 전에는 게시판 탭).
  on('bountyList', (m) => {
    S.bounty = m.rows || [];
    S.bountyPardons = m.pardons || []; // GUARD-R2 §5 — 면죄부 시세(서버 도출 — 손 미러 금지)
    if (eventTabShown('bounty')) renderPanel(true);
  });
  on('bountyPostAck', bountyPostAck);
  on('annList', (m) => {
    S.ann = m.rows || [];
    if (eventTabShown('ann')) renderPanel(true);
  });
  /**
   * 연결 상태를 **화면이 말하게 한다** (C-27).
   *
   * `S.connected` 는 쓰이기만 하고 읽는 곳이 0건이었다. 그래서 끊기면 화면이
   * 마지막 상태 그대로 얼어붙었고 — 몬스터도 내 캐릭터도 그 자리에 그대로 —
   * 알림은 전투 로그에 섞여 흘러가는 한 줄뿐이었다.
   * **자기가 끊긴 줄 모른 채 계속 클릭하게 된다.** 서버는 잔류(14.30)로 몸을 붙들어
   * 두는데(R182 부터 콘솔 「끊긴 몸 유지 시간」, 기본 60초) 화면이 그 시간을 침묵했다.
   */
  /**
   * R198(DESIGN 14.404) — 오래 끊기면 누를 것이 있어야 한다. 전에는 「다시 연결하는 중… (N번째)」만 끝없이 셌고, 덮개 안 버튼은
   * 숨어 있었고, 「나가기」 독은 덮개 아래라 못 눌렀다. 세 번째 재시도(또는 6초)부터 [지금 다시 시도]·[처음 화면으로] 를 보이고,
   * 인터넷이 끊겼으면(브라우저 `offline`) 그렇게 말한다. 30초가 넘으면 서버 쪽 사정일 수 있다고 말한다.
   */
  /**
   * 묶음 AB — 처음 LINK_QUIET_MS 동안은 화면 위쪽 작은 「다시 잇는 중」 표시만 둔다(`#link.quiet` — 누르기를 막지 않는다).
   * 전에는 1.5초 만에 전면 빨간 덮개에 「(2번째, 0초 후 재시도)」 내부 카운터까지 보였다 — 잠깐 흔들린 망에도 게임이 죽은 것처럼 보였다.
   * 유예가 지나도 안 붙으면 그때 전면 안내(이유·몸이 남는다·버튼)로 넘어간다. 재시도 횟수·대기 초는 사람에게 보이지 않는다.
   */
  const LINK_QUIET_MS = 4000, LINK_HELP_MS = 6000, LINK_LONG_MS = 30000;
  let linkDownAt = 0, linkHelpTimer = 0, linkLongTimer = 0, linkQuietTimer = 0, lastDrop = null, linkWasUp = false;
  /**
   * F39(DESIGN 14.539) — 붙어 있던(또는 들어가려던) 사냥터가 격리를 알렸다(`link` 의 `quarantine` — net.js `nativeRetry` 가 같은 사냥터로
   * 다시 붙는 동안 싣는다, F38 14.538). 다시 붙을 때까지 덮개가 그 까닭을 말한다
   */
  let quarantineFor = null;
  /**
   * UNI-Q250 — 이번 끊김은 배포로 원천 서버가 새 판으로 바뀌는 중이다(net.js `deployInProgress` 가 `link` 에 `updating` 을 싣는다).
   * 망이 끊긴 것도, 몸이 몬스터 앞에 남는 것도 아니다(원천이 통째로 다시 뜬다) — 「연결이 끊겼다 · 몸은 그 자리에 남는다」 대신 그렇게 말한다.
   */
  let linkUpdating = false;
  /** Q241 — 이번 끊김에서 원천이 몸을 잃었다고 알렸다(`link` 의 `bodyLost`). 다시 붙으면(또는 막다른 끊김이면) 지운다 */
  let bodyLostDrop = false;
  const linkIdle = () => {
    clearTimeout(linkHelpTimer); clearTimeout(linkLongTimer); clearTimeout(linkQuietTimer);
    linkHelpTimer = linkLongTimer = linkQuietTimer = 0; linkDownAt = 0; lastDrop = null; linkUpdating = false;
    $('#link')?.classList.remove('quiet');
  };
  const renderDrop = () => {
    const m = lastDrop; if (!m) return;
    if (linkWait.on) return;   // F39 — 이어받기 대기를 말하는 동안(`linkRecovery`)은 보통 끊김 문구로 덮지 않는다
    if (quarantineFor) {
      // F39 — 격리는 망 끊김이 아니다: 무슨 일인지 · 안전한지를 곧바로(조용한 유예 없이) 말한다. 다시 들어가는 것은 net.js 가 한다(F38 —
      // 같은 사냥터로 백오프 최대 8초 · 그 층이 저널에서 다시 서면 붙는다). 고정 간격으로 더 두드리게 하는 [지금 다시 시도] 는 두지 않는다
      $('#link')?.classList.remove('quiet');
      $('#linkhead').textContent = RECOVERY_HEAD.quarantined;
      $('#linkmsg').textContent = `${fieldDisplayName(quarantineFor)} 서버에 문제가 생겨 복구하는 중이다.\n캐릭터와 아이템은 마지막으로 저장된 그대로 안전하다.`;
      $('#linknote').textContent = '서버가 돌아오면 자동으로 다시 들어간다.';
      linkButtons({ home: true });
      return;
    }
    const offline = navigator.onLine === false;
    const since = linkDownAt ? performance.now() - linkDownAt : 0;
    const help = (m.tries || 0) >= 3 || since >= LINK_HELP_MS;
    $('#link')?.classList.toggle('quiet', !offline && since < LINK_QUIET_MS);
    if (linkUpdating && !offline) {
      // UNI-Q250 — 배포로 원천 서버가 새 판으로 다시 뜨는 중(보통 수십 초). 다시 이어지면 빌드 표식이 화면을 한 번 새로 고친다(net.js 빌드 분기)
      $('#linkhead').textContent = '서버를 새 판으로 바꾸는 중이다';
      $('#linkmsg').textContent = since < LINK_QUIET_MS ? '곧 다시 이어진다…' : '잠시 뒤 저절로 다시 이어진다.';
      $('#linknote').textContent = '캐릭터 기록은 그대로다 — 다시 이어지면 새 판으로 화면을 한 번 새로 고친다.';
      linkButtons({ retry: help, home: help });
      return;
    }
    $('#linkhead').textContent = offline ? '인터넷 연결이 끊겼다' : '연결이 끊겼다';
    $('#linkmsg').textContent = offline ? '인터넷이 다시 이어지면 곧바로 다시 연결한다.'
      : since < LINK_QUIET_MS ? '다시 잇는 중…' : '다시 연결하는 중…';
    $('#linknote').textContent = since >= LINK_LONG_MS && !offline
      ? '서버 점검이나 업데이트 중일 수 있다. 캐릭터 기록은 그대로다 — 기다리거나 처음 화면으로 돌아가도 된다.'
      : bodyLostDrop ? LINK_BODY_LOST_NOTE : linkHoldNote();
    linkButtons({ retry: help, home: help });
  };
  const showDead = (m) => {
    const t = LINK_DEAD[m.reason] || LINK_DEAD.default;
    $('#link')?.classList.remove('quiet');
    $('#linkhead').textContent = t.head;
    $('#linkmsg').textContent = t.msg;
    $('#linknote').textContent = t.note;
    linkButtons({ go: t.go !== false, home: true });
    // 밀려난 세션은 다시 이어 쓸 수 없다(R190) — 다음 입장이 곧장 세션을 새로 받게 한다
    if (m.reason === 'session superseded' || m.reason === 'session changed' || m.reason === 'field save refused') forgetResume();
    log(t.log, 'bad');
  };
  for (const ev of ['online', 'offline']) addEventListener(ev, () => { if (lastDrop && !S.connected && $('#link')?.classList.contains('on')) renderDrop(); });
  on('link', (m) => {
    if (!m.up) {
      storyIntro.close({ welcome: false }); hideReturnOptions(); releaseGoalClaim();
      if (S.petRevivePending) { clearTimeout(S.petRevivePending.timer); S.petRevivePending = null; }
    }
    const box = $('#link');
    if (!box) return;
    // Q241 — 아래의 숨김·첫 입장 분기보다 먼저 적는다(덮개가 나중에 뜰 때 문구가 사실을 말하게)
    if (m.bodyLost) bodyLostDrop = true;
    if (m.up || m.dead) bodyLostDrop = false;
    /**
     * R187 — 첫 입장 중의 「아직 안 붙음」은 끊김이 아니다. 가운데 판이 단계를 말하고 있으므로 「연결이 끊겼다」 덮개를 띄우지 않고,
     * 재시도 횟수만 판에 적는다. 붙으면(첫 상태) 판을 닫고, 재시도로 안 풀리는 실패(1008)면 판을 닫고 아래 안내로 간다.
     */
    if (entry.on) {
      /**
       * R190 — 세션 이어 쓰기가 거절됐다(다른 탭이 세션을 바꿈·몸을 못 받음). 막다른 안내 대신 곧바로 세션 교체 입장으로 넘어간다.
       * 재시도가 세 번째가 되도록 못 붙어도 같다 — 이어 쓰기는 빠를 때만 쓸모가 있다.
       */
      if (entry.resumed && !m.up && (m.dead || (m.tries || 0) >= 3)) {
        const charId = entry.charId;
        entry.resumed = false; forgetResume(); disconnect(); entryDone(); box.classList.remove('on');
        if (charId) void enter(charId, null, null, false, { noResume: true });
        return;
      }
      // R194 — 사냥터로 넘기는 중이면 원천 첫 상태에서 판을 닫지 않는다(넘기기가 끝나면 nativeTransition 이 닫는다)
      if (m.up) { if (!fieldHandoff) entryReady(); }
      else if (!m.dead) {
        box.classList.remove('on');
        if (m.tries > 1) entryShow('다시 연결하는 중…');   // 묶음 AB — 재시도 횟수는 내부 수치다(사람에게 안 보인다)
        return;
      } else entryDone();
    }
    /**
     * R187 — 사냥터로 넘어가는 중의 첫 연결은 끊김이 아니다(위 fieldHandoff). R193 — 사냥터에서 돌아오는 중(`transfer`)의 재시도도
     * 끊김이 아니다(원천이 아직 몸을 받을 준비가 안 돼 닫는 1013 이 흔하다). C9(14.476) — 넘는 칸에 닿았거나 인계 중인 동안(이동 표시가 기다리는 중 ·
     * `cueWaiting` — 25초 전)도 끊김 덮개 대신 이동 표시가 말한다(「연결 확인 중 — 잠시만」). 그 뒤는 이동 표시의 「눌러서 다시 잇기」다 — 창은 없다
     */
    if (!m.up && !m.dead && ((fieldHandoff && (m.transfer || (m.tries || 1) <= 1)) || cueWaiting())) {
      box.classList.remove('on');
      // 리드 실측(로컬 녹화 — Worker 재기동 동안 검은 화면에 표시 0): 끊김 덮개를 숨기는 동안엔 반드시 이동 표시가 말한다
      if (!cueWaiting()) showFieldShift('다시 연결하는 중…', null, 'reconnect');
      cueLinkWait(m.code);   // UNI-Q304 — 사냥터가 입장을 미룬 까닭을 「연결 확인 중」 뒤에 붙인다
      return;
    }
    // 덮개의 근거는 `S.connected` 다 — 이 값이 드디어 **읽히는 자리**가 생겼다.
    // 이벤트의 tries·wait 는 문구를 채우는 부가 정보일 뿐이다.
    const fresh = linkWasUp || !box.classList.contains('on');
    linkWasUp = !!m.up;
    box.classList.toggle('on', !S.connected);
    if (m.up) { linkIdle(); quarantineFor = null; linkButtons(); cueLinkUp(); return; }
    /**
     * **재시도로 안 풀리는 실패에는 나갈 길을 준다.**
     *
     * 세션이 밀리면(다른 탭·두 번 입장) 서버가 `1008` 로 닫는데, 클라가 같은
     * 낡은 세션으로 계속 다시 붙으러 가서 **무한 루프**가 됐다. 화면은 내내
     * "다시 연결하는 중…" 이라 사용자는 서버가 죽은 줄 알았고, **새로고침 말고
     * 나갈 방법이 없었다.** 막다른 길을 남겨두면 그건 버그다.
     */
    if (m.dead) { linkIdle(); quarantineFor = null; showDead(m); return; }
    // 묶음 AB — 덮개가 닫혀 있다가 새로 끊긴 것이면 시계를 새로 잰다(사냥터 넘기기 중의 옛 실패가 남긴 시각으로 유예를 건너뛰었다)
    if (fresh) linkIdle();
    lastDrop = m;
    if (m.quarantine) quarantineFor = m.quarantine;
    if (m.updating) linkUpdating = true;   // UNI-Q250 — 한 번 알면 이 끊김이 끝날 때까지(linkIdle) 유지한다 — 재시도 이벤트는 이 표시를 안 싣는다
    if (!linkDownAt) {
      linkDownAt = performance.now();
      linkHelpTimer = setTimeout(() => { if (!S.connected && box.classList.contains('on')) renderDrop(); }, LINK_HELP_MS + 50);
      linkLongTimer = setTimeout(() => { if (!S.connected && box.classList.contains('on')) renderDrop(); }, LINK_LONG_MS + 50);
      linkQuietTimer = setTimeout(() => { if (!S.connected && box.classList.contains('on')) renderDrop(); }, LINK_QUIET_MS + 50);
    }
    renderDrop();
  });
  /**
   * R196(DESIGN 14.404) — 사냥터가 아직 준비되지 않아(재시작·배포) 넘기기를 미뤘다. 몸은 살아 있는 원천에 그대로라 끊김 덮개가
   * 아니라 위쪽 작은 표시로 말한다(전에는 1초마다 전면 덮개가 번쩍였다). 다음 시도가 시작되면 「잇는 중」으로 바뀐다.
   */
  on('fieldWait', (m) => {
    if (m.done) { cueEnded(); return; }   // C9 — 넘지 못하고 끝났으면 뒤따르는 까닭(붉은 기록)을 이동 표시가 잠깐 말한다
    cueWait(m.wait / 1000);
  });
  /**
   * R194(DESIGN 14.404) · 묶음 X(T5, DESIGN 14.437) — 넘기는 동안 누른 것은 줄 세웠다가 붙는 순간 보낸다(net.js `flushHeldInputs`).
   * 누른 순간 「잇는 중」 표시만 곧바로 켠다. 너무 오래 걸려 보내지 않은 것만 말한다(채팅은 원문과 함께).
   */
  on('inputHeld', (m) => {
    if (!entry.on) showFieldShiftNow();
    if (!m.say) return;
    log(m.t === 'chat'
      ? `${handoffDoing} 채팅이 늦어 보내지 않았다 — 「${m.text}」 다시 보내 달라.`
      : `${handoffDoing} 오래 걸려 그 사이 누른 것 ${m.count || 1}개는 보내지 않았다. 다시 눌러 달라.`, 'bad');
  });
  on('closed', () => log('연결이 끊겼다. 다시 연결하는 중…', 'bad'));
}


/**
 * 소리를 낼 사건을 상태 변화에서 읽어낸다.
 * 서버가 이벤트를 따로 보내주지 않는 것들(피격·처치)을 여기서 잡는다 —
 * 소리 하나 때문에 프로토콜을 늘리면 대역폭이 100명분으로 곱해진다.
 */
let lastZone = null;
/**
 * 묶음 Z2 — 소리 연출(sound-director.js)은 첫 상태 틱에 받는다(첫 화면 로딩 바이트에 안 든다). 받기 전의 사건은 소리 없이 지나간다 —
 * 오디오는 어차피 첫 사용자 조작 전에는 열리지 않는다.
 */
let directorState = null;
function soundDirector() {
  if (directorState?.director) return directorState.director;
  if (!directorState) {
    directorState = { director: null };
    import('./core/sound-director.js').then((m) => { directorState.director = m.createSoundDirector(); })
      .catch(() => { directorState = null; });
  }
  return null;
}

/**
 * DESIGN 14.599 6단계 — 마을 구역의 몸은 원천 지도 좌표에 선다: 그 자리의 구역을 같은 판정(`zoneAt` — 서버와 거울 대조)으로 읽는다.
 * 게임 서버의 `you.zone` 은 입장 때 값 그대로라(사냥터는 한 구역이라 맞다) 마을 구역에서 탑·공성 전장·숲길로 걸어도 바뀌지 않았다.
 */
const zoneOf = (y) => (nativeTownRegion() ? zoneAt(y.x, y.y) : y.zone);

/** 월드의 수많은 세부 zone을 사람이 구별할 여섯 음악권과 네 갱도 사슬로 접는다. */
function audioScene(y) {
  const native = nativeFieldGeometry();
  // 묶음 Z2b — 종말 행군 중의 지상은 종말 곡(갱도·탑·공성 전장은 제 곡). 드래곤이 세상을 가로지르는 날이다
  const doom = !!S.doom?.active;
  if (native) {
    const floor = nativeFieldFloor();
    if (floor) return `cave_${floorOf(floor).chain}`;
    if (doom) return 'doom';
    if (native.theme === 'rift' || native.theme === 'desert') return native.theme;
    if (native.theme === 'forest' || native.theme === 'fairy') return 'forest';
    if (['mainland', 'moor', 'mire'].includes(native.theme)) return 'mainland';
    return 'island';
  }
  if (y.inv?.towerActive) return 'cave_main';
  if (siegeArenaAt(y.x, y.y)) return 'siege'; // UNI-Q186 — 공성전 전장. 묶음 Z2b 부터 자기 곡(전장 북·화성단조 행진)
  const fl = floorAt(y.x, y.y);
  if (fl > 0) return `cave_${floorOf(fl).chain}`;
  if (doom) return 'doom';
  const settled = settlementAt(y.x, y.y);
  if (settled && settled.id !== 'outpost') return 'town';
  const zone = zoneOf(y);
  if (zone === 'fairy') return 'forest'; // 묶음 Z2b — 숲은 자기 곡(도리아 선법·목관·하프). 전에는 섬 녹음을 같이 썼다
  if (zone === 'rift') return 'rift';
  if (zone === 'desert') return 'desert';
  if (['mainland', 'moor', 'mire'].includes(zone)) return 'mainland';
  return 'island';
}

/** 묶음 Z2b — 갱도 사슬 안의 깊이 0(첫 층)~1(마지막 층). 깊을수록 배경음이 낮고 성기고 어둡다 */
function audioDepth(y) {
  const n = nativeFieldGeometry() ? nativeFieldFloor() : floorAt(y.x, y.y);
  if (!n) return 0;
  const here = floorOf(n);
  const chain = FLOORS.filter((f) => f.chain === here.chain);
  return chain.length > 1 ? chain.indexOf(here) / (chain.length - 1) : 0;
}

function watchEvents() {
  const y = S.you; if (!y) return;
  setMusicConfig(y.atmo); // H4(DESIGN 14.486) — 콘솔 배경 음악 기본 음량·곡 사이 쉼(섬은 상태 패킷, 사냥터 안은 정책 갱신 `atmo`). 바뀐 값만 반영한다
  setMusicScene(audioScene(y));
  setMusicDepth(audioDepth(y));
  // 묶음 Z2 — 피격·처치음은 그림이 닿는 순간(위 onImpact)에 난다. 여기서는 그림 없는 피해·처치의 안전판과 환경음·발소리·예고음(sound-director.js)
  soundDirector()?.state(S, audioScene(y));
  const zone = zoneOf(y);
  if (lastZone !== null && zone !== lastZone) {
    if (zone === 'dungeon' || lastZone === 'dungeon') SFX.portal();
    if (zone === 'dungeon' && y.inv?.towerActive) {
      log('시련의 탑이다. 층을 통과한 뒤 다음 층에 도전하거나 귀환할 수 있다. 고르지 않으면 잠시 뒤 자동으로 다음 층에 도전한다. 실패하면 탑 보상만 잃으며, 사용한 물약은 소모된다.', 'info');
      flash('#6d619b');
    } else if (zone === 'dungeon' && siegeArenaAt(y.x, y.y)) {
      // UNI-Q186 — 전장은 PK 지역이 아니다: 싸움은 공성전 판정 하나(떨굼·범죄·성향 없음)
      log('공성전 전장이다. 열린 길 하나의 적 방어탑 둘(바깥 → 안쪽) → 성문 → 본진 순으로 무너뜨린다. 「보호」 목표는 앞선 목표부터 공략한다. 평타로 싸우며 물약 대신 우리 본진에서 회복한다. 쓰러져도 아무것도 떨구지 않고 잠시 뒤 본진에서 다시 선다. 화면의 공성전 안내를 누르면 규칙과 나가기 버튼이 나온다.', 'info');
      flash('#a33b32');
    } else if (zone === 'dungeon') {
      /**
       * ⚠ **문장을 여기 적지 않는다.** 전에는 *"여기서는 사람이 사람을 죽일 수 있다"*
       * 라고 **자기 말로** 적혀 있었다 — 같은 규칙을 말하는 **다섯 번째 사본**이었고,
       * 표지판·다리·HUD 와 **낱말까지 달랐다**(`죽일` vs `칠`). 규칙이 바뀌면
       * 넷은 따라가고 이것만 남는다.
       *
       * 갱도 입구 딱지와 **같은 문구**를 쓰고 **풀이(`PK_GLOSS`)를 붙인다** —
       * 섬에서 자란 사람에게 **갱도가 PK 를 처음 만나는 자리**다(본토는 다리를
       * 건너야 하고 그건 Lv20 뒤다). 다리·표지판에 풀이를 붙이는 것과 같은 이유다.
       */
      log(`갱도다. 여기는 ${PK_WARN.cave} — ${PK_GLOSS}.`, 'bad');
      flash('#a33b32');
    }
  }
  lastZone = zone;
}
/**
 * R201(DESIGN 14.404) — 모듈 그래프 전체와 이 파일의 최상위 코드가 끝까지 돌았다. index.html 의 부트 감시가 이 표식이 없으면
 * 「게임을 불러오는 중…」 판에 까닭과 [다시 불러오기] 를 띄운다(전에는 모듈 하나만 못 받아도 그 판에서 영원히 멈췄다).
 */
window.__unigeBooted = true;
{ // 느린 망에서 감시가 먼저 문구를 띄웠다가 늦게라도 다 받았으면, 그 문구·버튼이 입장 판(같은 판)에 남지 않게 치운다
  const again = $('#loadreload');
  if (again && !again.hidden) {
    again.hidden = true;
    const note = $('#page-loading .loadnote'); if (note) { note.textContent = ''; note.hidden = true; }
  }
}
